export const enTranslations = {
  localeCode: 'en',
  misc: {
    boolean: {
      true: 'yes',
      false: 'no',
    },
    languages: {
      PL: 'PL',
      GB: 'EN',
    },
    button: {
      cancel: 'Cancel',
      create: 'New',
      delete: 'Delete',
      details: 'Details',
      list: 'List',
      save: 'Save',
      send: 'Send',
      search: 'Search',
      addFunction: 'Add function',
      deleteFunction: 'Delete function',
      print: 'Print',
      publish: 'Publish',
      unpublish: 'Revert',
      reset: 'Reset',
      edit: 'Edit',
      copy: 'Copy',
      close: 'Close',
      mail: 'Mail',
      addItem: 'Add item',
      upload: 'Upload file',
      uploadPdf: 'Upload file (pdf)',
      generateInvoice: 'Invoice',
      finish: 'Finish',
      next: 'Next',
      prev: 'Previous',
      new: 'Add',
      import: 'Import',
      complete: 'Complete',
      accept: 'Accept',
      generate: 'Generate file',
      download: 'Download file',
      openAll: 'Open all',
      closeAll: 'Close all',
      confirm: 'Confirm',
      export: 'Export',
      yes: 'Yes',
      no: 'No',
      reject: 'Reject',
      updateBookingRequest: 'Update booking',
      cancelBookingRequest: 'Cancel booking',
      copyEvent: 'Copy event',
      duplicate: 'Duplicate',
      saldeoFetch: 'Fetch from Saldeo',
      enovaFetch: 'Fetch from Enova',
      showMore: '+{{count}} more...',
    },
    message: {
      generalError: 'Error: ',
      deleteSuccess: 'Entry deleted.',
      deleteFailure: 'Error occured while deleting entry.',
      createSuccess: 'Entry created.',
      createFailure: 'Error occured while creating entry.',
      duplicateSuccess:
        'A duplicate rate has been created. Moved to the newly created rate page.',
      duplicateFailure: 'Error occured while duplicating the rate.',
      updateSuccess: 'Entry updated',
      updateFailure: 'Error occured while updating entry.',
      accessDenied: 'Insufficient permissions to perform operation.',
      contactAdministrator: 'Contact the administrator',
      acceptSuccess: 'Allocation accepted',
      gusError: "Can't access data from GUS",
      updateUserPermissions:
        'Permissions updated. Changes will be visible after relogging.',
      exportSuccess: 'Exported {{exported}} of {{total}} invoices.',
      exportPartial:
        'Sent {{exported}} of {{total}} invoices. Check errors and/or contact administration.',
      exportFailed:
        'No invoice was exported. Check errors and/or contact administration.',
      lackOfDueDays:
        'Contact the responsible person to define counterparty payments terms.',
      downloadFailed: 'Preparing download failed.',
      newMessage: 'New message!',
      outdatedOwnInvoices:
        'You have own invoices waiting for publication, please publish or cancel them ',
      outdatedAdministrativeInvoices:
        'You have administrative invoices waiting for publication, please publish or cancel them ',
      goToOutdatedInvoices: 'here.',
      bookingRequestSend: 'Booking Request sent',
      bookingRequestUpdated: 'Booking update sent',
      bookingRequestCancelled: 'Booking cancellation sent',
    },
    status: {
      INTERNAL_SERVER_ERROR: 'Internal server error',
      BAD_REQUEST: 'Invalid request',
      NOT_FOUND: 'Not found',
    },
    errors: {
      BaseInvoiceMissingKsefNumber:
        'The base invoice has no KSeF number in Storm. Import the KSeF confirmation to issue a corrective invoice.',
      DataAccess: 'Data access failure.',
      DeletingOwnInvoice: 'Published own invoices cannot be canceled.',
      EncryptionFailed: 'Encryption failed.',
      EntityNotFound: 'Requested object does not exist.',
      ForbiddenReplacementAttempt: 'You may not replace selected user.',
      HttpParsing: 'Bad request format.',
      InvoiceAllocationSum:
        'Łączna suma alokacji jest większa od wartości faktury.',
      ItemDisabled: '{{1}} {{2}} is disabled.',
      ItemDisabledTypes: {
        Region: 'Region',
        ContainerSize: 'Container size',
        CurrencyCode: 'Currency code',
        Forecast: 'Forecast',
        ProductGroup: 'Product group',
        Clause: 'Clause',
        Unit: 'Unit',
        Trucker: 'Trucker',
        Terminal: 'Terminal',
        ShippingLine: 'Shipping line',
        Agent: 'Agent',
        CustomsAgency: 'Customs agency',
        Customer: 'Customer',
        Other: 'Other',
        Depot: 'Depot',
        Insurer: 'Insurer',
        User: 'User',
        TransportMode: 'Transport mode',
        Port: 'Port',
        StoreHouse: 'Store house',
        Package: 'Package',
        EDIParty: 'EDI party',
        Role: 'Role',
        Counterparty: 'Counterparty',
        Responsibility: 'Position',
        InvoiceClass: 'Invoice class',
        ItemConfiguration: 'Item configuration',
        Container: 'Container',
        Group: 'Group',
        Lot: 'Lot',
        Branch: 'Branch',
        TaxRate: 'Tax rate',
        Activity: 'Activity',
        ContainerType: 'Container type',
      },
      NoActiveReplacement: 'No active replacement.',
      NoDefaultUnit: 'No default activity unit set.',
      NoPrimaryCounterparty: 'No primary counterparty set.',
      NoPrimaryCurrencyCode: 'No primary currency set.',
      Storm: 'Application error.',
      XmlSerialization: 'Invoice export failed.',
      DeletingCorrectedInvoice:
        'Cannot delete corrected invoice without deleting corrective invoice first.',
      ExchangeRateNotFound: 'Exchange rate for selected currency not found.',
      NoEmailCredentials: 'Cannot send email with no email settings set',
      DeletingCustomerWithOffer:
        'Cannot delete customer who has offer prepared',
      DeletingJobWithAllocatedInvoice:
        'Cannot delete job that has allocated invoices.',
      TerminalPriceExists:
        'Terminal price for selected configuration already exists.',
      InvalidCountryCode: 'Invalid country code selected.',
      RowAlreadyExists: 'Cannot insert because row already exists',
      ContainerAlreadyPresentInJob:
        'Container with this number is already present in job.',
      BusinessFunctionTypeAlreadyPresent:
        'Counterparty already has this function.',
      NotPossibleToDelete:
        'It is not possible to delete the object becasue it has active connections in the system.',
      TransportRateOverlap: 'Distances are overlapping with other records',
      ItemConfigurationExists:
        'Configuration for selected item type, relation and category already exists.',
      ItemConfigurationDisabledForActivity:
        'Configuration incorrect. Selected Relation is not allowed for selected Activity. Check Activity configuration.',
      ActivityModificationNotPossible:
        'Modification not possible. The disabled Code - Relation combination is already used in Items configuration.',
      PrimaryCounterpartyInvalidFunction:
        'Added function is not a valid selection for primary counterparty',
      CannotSendMail:
        'Not possible to send mail - email settings incorrect (wrong email login)',
      CannotAuthenticateMail:
        'Not possible to send mail - email settings incorrect (wrong email password)',
      UserLoggedIn: 'Cannot delete user that is currently logged in.',
      DeletingAllocatedInvoiceLine:
        'Cannot delete an invoice line from allocated invoice',
      ExcelImportFormat: 'Uploaded excel file is not formatted properly.',
      ExcelImportCellData: 'Invalid data in sheet %1 cell %2',
      ExcelImportEntityData: 'Invalid data in sheet %1 row %2',
      InvoiceDeleted: 'Action cannot be performed on deleted invoice.',
      InvoiceIssueDate: 'Invalid issue date',
      InvoiceNotPublished: 'Corrected invoice was not published.',
      UnknownInvoiceClass: 'Unknown invoice class.',
      PreviousPassword: 'Incorrect password. Try again.',
      UserIsKeeper:
        'This user cannot be set as client panel user because he already is a keeper for one of customers.',
      InvoiceAlreadyCorrected: 'Invoice has already been corrected.',
      GUSCounterpartyNotFound: 'Counterparty not found in GUS database.',
      GUSInvalidCaptcha: 'Incorrect captcha.',
      GUSServiceLoginFailed: 'Failed to connect to GUS service.',
      GUSSessionExpired: 'Incorrect captcha.', // this is intentionally the same as GUSInvalidCaptcha - no need to burden the user with unneccessary technical details
      NoDocument: 'Printing this document is nor possible.',
      AccountingDocumentIsCancelled: 'Invoice is already cancelled.',
      AccountingDocumentIsExported: 'Invoice is already exported.',
      AccountingDocumentIsNotReady: 'Invoice must be published first.',
      AccountingDocumentIsNotDraft: 'Invoice is not a draft.',
      JobIsBilled: 'Job is already billed.',
      JobIsCancelled: 'Job is already cancelled.',
      JobIsNotFinalized: 'Job must be finalized first.',
      JobAccountEntryIsAccepted: 'Allocation is already accepted.',
      AcceptedAllocations: 'There is at least one accepted allocation.',
      ExistingAllocations: 'There are existing alocations.',
      JobExecutionDateNotSet: 'No job execution date set.',
      ExistingNotExportedInvoices: 'There are not exported invoices.',
      MissingOwnInvoiceAllocation: 'No own invoice allocation for this job.',
      AllocationProcessIsNotFinished: 'Allocation process is not finished.',
      JobIsNotOpen: 'Job is closed.',
      JobAccountEntryLimitExceeded:
        'Allocation sum is greater than invoice net amount.',
      OwnAccountingDocumentInvalidOperation:
        'Operation not allowed for own invoice.',
      JobAccountEntryIsNotAccepted:
        'There is at least one not accepted allocation.',
      JobIsFullyInvoiced: 'Every job item in this job is invoiced.',
      NoJobItemsToInvoice: 'Job {1} has no job items that can be invoiced.',
      JobHasLessItemsThanInvoiced:
        'Job has currently less items than previously invoiced.',
      NotSuperUser: 'Superuser permissions required.',
      NoInvoicesToExport: 'No invoices to export.',
      DeletedInvoiceLineStillPresent:
        'Removed invoice line was still sent in all lines, please retry after refreshing the page.',
      InvoiceLineAmountSumMismatch:
        'Invoice line net value sum does not match total value on invoice.',
      UploadedFileSizeLimitExceeded: 'Uploaded file is bigger than 10MB.',
      StorehouseExistsInDatabase: 'Storehouse exists in database.',
      EmptyFields: 'Not all required fields are filled.',
      ClientRolePermission:
        "Role can't have other privileges when having a client privilege.",
      CustomerNotSelected:
        "One of the users assigned to the role hasn't got client panel account.",
      OceanSchedulesAuthenticationFailed: 'Inttra authentication failed',
      OceanSchedulesInvalidRequest: 'Invalid Ocean Schedule query request',
      WrongServiceTermsFileExtension:
        'Wrong service terms file extension. Please add a pdf file.',
      InvalidTrackAndTraceFile: 'Received Track and Trace file has some errors',
      SendingWithoutInttraReference:
        'Inttra ref. not found in Booking Confirmation.',
      OceanSchedulesInternalError: 'Internal service error on Inttra side',
      ShippingInstructionNotFound:
        'Shipping instruction not found for container {1}',
      BookingRequestNotFound:
        'Acknowledged booking request not found for container {1}',
      FreightNotFound: 'Freight service not found for container {1}',
      TerminalNotSupported: 'Not supported terminal',
      JiraConnection: 'Error reporting temporarily unavailable.',
      ClientGroupPermission:
        'Client permission group can only have client permission role assigned.',
      NoCorrectedLines:
        'Publication is not possilbe without invoice lines specified.',
      EmptyScacCode: 'SCAC code is not set for selected shipping line.',
      BrFormValidation:
        "Booking request form doesn't contain all required fields for selected carrier party. {1}.",
      UserWithoutPhone: 'Please fill phone number in your profile',
      InvoiceLineFromJobHasNegativeQuantity:
        'One of job items has too many invoiced entries',
      SeaportCodeExists: 'Seaport code is already set for port {2}, {1}',
      InvoiceAlreadyExported:
        'Selected invoice was already exported. In is not possible to export invoice twice.',
    },
    modal: {
      header: 'Warning',
      createEntityHeading: 'Create entry',
      updateEntityHeading: 'Update entry',
      copyEntityHeading: 'Copy entry: ',
      deleteEntityHeading: 'Confirm deletion',
      deleteEntityBody: 'Are you sure you want to delete this entry?',
      deleteRateBody: 'Are you sure you want to delete selected rates?',
      deleteEntityForeverBody:
        'Are you sure you want to delete this entry? This operation cannot be undone.',
      publishHeading: 'Publish',
      publishOfferBody:
        'Are you sure you want to publish offer? This operation cannot be undone.',
      publishAnnexBody:
        'Are you sure you want to publish annex? This operation cannot be undone.',
      publishInvoiceBody: 'Are you sure you want to publish invoice?',
      publishAlert: 'After publication invoice will be visible in client panel',
      acceptAllocationHeading: 'Confirm allocation acceptance',
      acceptAllocationBody:
        'Are you sure you want to accept allocation? This operation cannot be undone.',
      rejectAllocationHeading: 'Confirm rejecting allocation',
      rejectAllocationBody:
        'Are you sure you want to reject allocation? This operation cannot be undone.',
      rejectAllocationReasonLabel: 'Please provide the complaint reason:',
      markForCorrectionAllocationHeading: 'Confirm complaining allocation',
      markForCorrectionAllocationBody:
        'Are you sure you want to place a complaint?',
      markForCorrectionAllocationReasonLabel:
        'Please provide the complaint reason:',
      clearCorrectionRequiredMarkingHeading: 'Reject complaint',
      clearCorrectionRequiredMarkingBody:
        'Are you sure you want to reject invoice complaint?',
      updateUserPermissionsHeading: 'Update user permmisions.',
      updateUserPermissionsBody: 'Changes will be visible after relogging.',
      unpublishHeading: 'Revert publishing',
      unpublishInvoiceBody:
        'Are you sure that you want revert publishing? Any financial changes will delete all existing allocations.',
      exportInvoiceHeader: 'Export',
      exportInvoiceBody:
        'Are you sure you want to export selected invoices? This operation can not be undone.',
      deleteCorrectedHeading: 'Deleting invoice',
      deleteCorrectedBody:
        'There are corrective invoices for this invoice. Deleting this invoice will delete also all corrective invoices. Are you sure?',
      publishOfferAlert:
        'After publication offer will be visible in client panel',
      publishAnnexAlert:
        'After publication annex will be visible in client panel',
      currencyWarningBody:
        'Changing currency will remove all items added to the invoice. Are you sure you want to change the currency?',
      withdrawCorrectingAllocationHeading: 'Confirm complaint withdrawal',
      withdrawCorrectingAllocationBody:
        'Are you sure you want to withdraw a complaint? This operation cannot be undone.',
    },
    combobox: {
      noMatches: 'No matches found',
      loadMore: 'Loading more results...',
      searching: 'Searching...',
    },
    offerCompleted: {
      COMPLETED: 'completed',
      UNCOMPLETED: 'uncompleted',
    },
    amount: 'Amount',
    load: 'Load',
    name: 'Name',
    enabled: 'Enabled',
    disabled: 'Disabled',
    comment: 'Internal comment',
    creationDate: 'Creation date',
    executionDate: 'Execution date',
    expirationDate: 'Expiration date',
    description: 'Description',
    terminals: 'Terminals',
    data: 'Data',
    summary: 'Summary',
    details: 'Detailed view',
    code: 'Code',
    inttraName: 'Name',
    type: 'Type',
    size: 'Size',
    value: 'Value',
    percentValue: 'Value (%)',
    edit: 'Edit',
    date: 'Date',
    owner: 'Owner',
    label: 'Label',
    actions: 'Actions',
    file: 'File',
    startDate: 'Start issue date',
    endDate: 'End issue date',
    body: 'Body',
    onlyMine: 'Only mine',
    onlyCurrent: 'Only current',
    onlyUnacceptedAllocations: 'Unaccepted allocations',
    from: 'From',
    to: 'To',
    unit: 'Unit',
    onlyWithTerminals: 'Only with terminals',
    table: 'Table',
    year: 'Year',
    sender: 'Sender',
    ordinal: '#',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    selectAll: 'Select all',
    language: 'Language',
  },
  offer: {
    code: 'Offer number',
    data: 'Offer data',
    publicationDate: 'Publication date',
    receiveDate: 'Publication date', // TODO: publicationDate !== receiveDate in PL
    owner: 'Owner',
    tradeType: 'Relation',
    netAmount: 'Net amount',
    grossAmount: 'Gross amount',
    markup: 'Markup',
    currencyCode: 'Currency',
    customer: 'Customer',
    record: 'Record',
    ordinalNumber: 'Ordinal number',
    customsAgency: 'Customs agency',
    depot: 'Depot',
    insurer: 'Insurer',
    agent: 'Agent',
    shippingLine: 'Shipping line',
    terminal: 'Terminal',
    trucker: 'Trucker',
    unit: 'Unit',
    activity: 'Activity',
    quantity: 'Quantity',
    route: 'Route',
    approximateShippingTime: 'TT',
    addRecord: 'Add annex',
    createOfferFromTemplate: 'Create offer',
    createOffer: 'Create offer',
    createOfferTemplate: 'Create offer template',
    copyOffer: 'Copy offer',
    copyTemplate: 'Copy template',
    fromWaypoint: 'From',
    toWaypoint: 'To',
    relayWaypoints: 'Through',
    insuranceRate: 'Rate ‰',
    insuranceDescription: '%1‰ from %2% load value',
    multiplyFactor: 'Multiplier %',
    items: 'Offer',
    annex: 'Annex',
    createTemplate: 'Create template',
    addItem: 'Add item',
    offerPublicated: 'After publication offer will be visible in client panel',
    annexPublicated: 'After publication annex will be visible in client panel',
    clientPanelDraft:
      'Full offer is available on the printouts. The following view is only demonstrative!',
    cyclicalOffer: 'Cyclical offer',
    reminderLabelBefore: 'Remind me',
    reminderLabelAfter: 'days before expiration',
    reminderDateError: "Reminder can't exceed todays date",
    job: {
      createJobButton: 'Create job',
      modalHeader: 'Job',
      modalSave: 'Create',
      codeInfo: 'assigned automatically',
      executionDateInfo: 'set after creation',
      ownerInfo: 'current user',
      noJobWithoutCustomer:
        'To create job add customer function to current counterparty.',
    },
    item: {
      allin: 'All-in',
      customs: 'Customs',
      depot: 'Depot',
      freight: 'Freight',
      freightmaintenance: 'Freight maintenance',
      insurance: 'Insurance',
      other: 'Other',
      terminal: 'Terminal',
      transport: 'Land transport',
    },
    offerType: 'Offer type',
    offerTypeLabels: {
      OFFER: 'Offers',
      TEMPLATE: 'Templates',
    },
    createOrder: 'Create order',
    order: 'Order',
    orderWizard: {
      summaryInformation:
        'Sending a job does not mean taking it to realization. Acceptation of order must be confirmed by an employee of the company',
      information:
        'Please select only one route associated with one bill of lading.',
      modalHeader: 'Order',
    },
    exchangeRate: '{currency} Exchange rate',
    allInMoreThanOneFreight: 'All-in can contain only one freight.',
    expirationDate: 'Offer expiration date',
  },
  order: {
    order: 'Order',
    recipent: 'Order recipient',
    productGroup: 'Product group',
    loadName: 'Load name',
    readinessDate: 'Readiness date',
    customsClearanceType: 'Customs clearance type',
    customsClearanceAddress: 'Custom clearance address',
    containerCount: 'Number of containers',
    quantity: 'Quantity',
    totalWeight: 'Total weight of load',
    totalCubature: 'Total cubature of load',
    comment: 'Comments',
    sent: 'Order sent',
    orderReceive:
      'You received new order {0} (Todo: no order table). Click to view the details.',
    orderNumber: 'Order number',
    offerNumber: 'Offer number',
    sendDate: 'Date of sending',
    recipient: 'Recipient',
    createJob: 'Create job',
    rejectOrderHeader: 'Reject',
    rejectOrderBody: 'Are you sure you want to reject this order?',
    reject: 'Reject',
    status: {
      SENT: 'Received',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      label: 'Order status',
    },
    clientStatus: {
      SENT: 'Sent',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
    },
  },
  job: {
    job: 'Job',
    code: 'Job number',
    invoiceButtonJobItemsHint:
      'Issuing invoice is not possible - all services have already been invoiced.',
    invoiceButtonContainerHint:
      'Issuing invoice is not possible – please fill container numbers.',
    estimation: 'ETA/ETD',
    customsClearance: 'Cleared',
    creation: {
      differentFreightRoutes: 'All freights must have the same route.',
    },
    search: {
      startCreationDate: 'Start creation date',
      endCreationDate: 'End creation date',
      withMissingVgm: 'VGM',
    },
    general: {
      tabTitle: 'Info',
      data: {
        sectionTitle: 'Job data',
        commissioner: 'Commissioner',
        tradeType: 'Relation',
        loadType: 'Category',
        customer: 'Customer',
        offer: 'Offer',
        goToOffer: 'Go to offer',
        goToOrder: 'Go to order',
        readinessDate: 'Readiness date',
        bookingNumber: 'Booking number',
        netValueAllocationSum: 'Financial result',
        netValueAllocationSumForecast: 'Result forecast',
        owner: 'Owner',
        futureExecutionDate:
          'Please enter a date between {0} and current date.',
        executionConfirmationBody:
          'The following services do not have filled all the details necessary to issue an invoice for them:',
        executionConfirmationHeader: 'Confirm job execution',
        executionConfirmationContinue: 'Do you want to continue?',
        bookingRequestAttachmentDownload: 'Download attachment',
        status: 'Status',
        statusLabels: {
          IN_PROGRESS: 'In progress',
          FINALIZED: 'Finalized',
          BILLED: 'Billed',
          CANCELLED: 'Cancelled',
        },
      },
    },
    entries: {
      ContainerJobEntry: 'Container',
      ContainerJobEntryTotal: 'Sum',
      TarpaulinJobEntry: 'Tarpaulin',
      SmallLoadJobEntry: 'Small load',
      releaseContainerUnderDetention: 'Release detention status',
    },
    loads: {
      captured: 'Captured',
      tabTitle: 'Loads',
      productGroup: 'Product group',
      bulk: 'Bulk',
      quantity: 'Pallet quantity',
      packageType: 'Package type',
      packageCount: 'Package count',
      loadDescription: 'Load description',
      netWeight: 'Net weight (kg)',
      grossWeight: 'Gross weight (kg)',
      declaredWeight: 'Weight',
      seals: 'Seals',
      harmonizedSystemCode: 'HS code',
      containerCode: 'Container number',
      containerSize: 'Container size',
      containerType: 'Container type',
      containerSort: 'Container sort',
      containerSortShort: 'Type',
      relatedServices: 'Items',
      createJob: 'Details',
      summary: 'Summary',
      route: 'Route',
      hideTrucker: 'Hide trucker',
      showTrucker: 'Show trucker',
      hideRoute: 'Hide route',
      showRoute: 'Show route',
      contactPerson: 'Contact person',
      technicalStateControl: 'Technical state control',
      waybillClauses: 'Waybill clauses',
      containerOrderClausesImport: 'Container discharge order clauses',
      containerOrderClausesExport: 'Container pickup order clauses',
      transportMode: 'Required transport mode',
      stackable: 'Stackable',
      adr: 'ADR',
      unCode: 'UN code',
      adrClass: 'ADR class',
      packingGroup: 'Packing group',
      exportCustomsClearance: 'Export',
      importCustomsClearance: 'Import',
    },
    items: {
      AllInJobItem: 'All-in',
      CustomsJobItem: 'Customs',
      DepotJobItem: 'Depot',
      FreightJobItem: 'Freight',
      FreightMaintenanceJobItem: 'Freight maintenance',
      InsuranceJobItem: 'Insurance',
      TerminalJobItem: 'Terminal',
      TransportJobItem: 'Transport',
      OtherJobItem: 'Other',
    },
    counterparties: {
      CustomsJobItem: 'Customs agency',
      DepotJobItem: 'Depot',
      FreightJobItem: 'Shipping line',
      FreightMaintenanceJobItem: 'Shipping line',
      InsuranceJobItem: 'Insurer',
      TerminalJobItem: 'Terminal',
      TransportJobItem: 'Trucker',
      OtherJobItem: 'Counterparty',
    },
    services: {
      createItem: 'Add service',
      tabTitle: 'Services',
      activity: 'Activity',
      unit: 'Unit',
      price: 'Price',
      customsAgency: 'Customs Agency',
      shippingLine: 'Shipping Line',
      insurer: 'Insurer',
      trucker: 'Trucker',
      otherFunction: 'Service',
      relatedLoads: 'Loads',
      door: 'Door',
      agent: 'Agent',
      billOfLadingNumber: 'B/L',
      estimatedDelivery: 'Estimated delivery',
      valueAmount: 'Value amount',
      insuranceRate: 'Rate ‰',
      multiplyFactor: 'Multiply factor',
      driver: 'Driver',
      driverName: 'Driver name',
      driverEmail: 'Driver email',
      driverPhone: 'Driver phone number',
      driverDocumentNumber: 'Driver document',
      vehicleRegistrationNumber: 'Truck registration number',
      trailerRegistrationNumber: 'Trailer registration number',
      trailerNumber: 'Trailer number',
      fromOffer: 'Service from offer',
      route: 'Route',
      shipName: 'Ship name',
      tripNumber: 'Trip number',
      cutOff: 'Cut off',
      ETD: 'ETD',
      loadingPort: 'Port of loading',
      ETA: 'ETA',
      unloadingPort: 'Port of unloading',
      loadDate: 'Load date',
      unloadDate: 'Unload date',
      executionDate: 'Execution date',
      showPriceTag: 'Show price',
      hidePriceTag: 'Hide price',
      customsClearance: 'Customs clearance place',
      additionalRemarks: 'Additional remarks',
      insuranceDescription: '%1‰ from %2% load value',
      exchangeRate: '{currency} Exchange rate',
      customsClearances: {
        noClearance: 'No clearance',
        other: 'Other',
        IMPORT: {
          done: 'Cleared',
          inProgress: 'Transit',
        },
        EXPORT: {
          done: 'At place',
          inProgress: 'At port',
        },
        // FIXME: need name for these
        COUNTRY: {
          done: '?',
          inProgress: '?',
        },
      },
      doorDate: {
        IMPORT: 'Pickup date',
        EXPORT: 'Delivery date',
      },
    },
    documents: {
      tabTitle: 'Documents',
      types: {
        blData: 'B/L data',
        waybill: 'Waybill letters',
        transportOrder: 'Transport orders',
        notification: 'Notifications',
        acceptanceConfirmation: 'Job acceptance confirmation',
        shippingInstructions: 'Shipping Instructions',
        customsMessages: 'Customs documents',
      },
      job: 'Job',
      jobEntry: 'Job entry',
      documentNumber: 'Document number',
      generationDate: 'Generation date',
      sendDate: 'Date of sending',
      documentsWarnings: {
        withoutFreight:
          'To be able to generate document, you must add freight service',
      },
      filename: 'File name',
      containerNo: 'Container number',
      receiveDate: 'Receive date',
    },
    events: {
      tabTitle: 'Events',
      sectionTitle: 'Events',
      note: 'Note',
      mail: 'E-mail',
      attachment: 'Attachment',
      mailSent: ' has been sent.',
      defaultMessage: 'Document has been sent.',
    },

    communications: {
      tabTitle: 'Communication',
      shippingLines: 'Shipping lines',
      terminals: 'Terminals',
      trackAndTrace: 'Track&Trace',
      sendNotification: 'Send container notification',
      containerNotificationSent:
        'Notification send for container {containerNumber}',
      status: {
        NOT_SENT: 'Not sent',
        SENT: 'Sent',
        REJECTED: 'Rejected',
        ACKNOWLEDGED: 'Received',
        CANCELLED: 'Cancelled',
        TECH_REJECTED: 'Tech. rejected',
        CONFIRMED: 'Confirmed',
        UPDATED: 'Updated',
      },

      carriageCondition: {
        label: 'Carriage condition',
        DOOR_TO_DOOR: 'Door to Door',
        DOOR_TO_PIER: 'Door to Pier',
        PIER_TO_DOOR: 'Pier to Door',
        PIER_TO_PIER: 'Pier to Pier',
      },
      cargoTypes: {
        AWKWARD: 'Awkward',
        DANGEROUS: 'Dangerous',
        GENERAL: 'General',
        REEFER: 'Reefer',
        AWKWARD_DANGEROUS: 'Awkward dangerous',
        REEFER_DANGEROUS: 'Reefer dangerous',
      },
      bookingRequest: {
        title: 'Booking Request',
        documentNumber: 'Document number',
        bookingNumber: 'Booking number',
        generationDate: 'Generation date',
        status: 'Status',
        dateOfSending: 'Date of sending',
        receiver: 'Booking request receiver',
        details: 'Details',
        new: 'New',
        pickup: 'Pickup date',
        placeOfPickup: 'Place of pickup',
        loading: 'Place of loading',
        discharge: 'Place of discharge',
        delivery: 'Place of delivery',
        earliestDeparture: 'Earliest departure date',
        ultimateDeparture: 'Ultimate departure date',
        earliestArrival: 'Earliest arrival date',
        ultimateArrival: 'Ultimate arrival date',
        dates: 'Booking Request dates',
        chooseDateType: 'Choose date type',
        carriage: 'Carriage condition',
        referenceNumber: 'Reference number',
        inland: 'Inland location',
        carrier: 'Carrier',
        bookingParty: 'Booking party',
        shipperParty: 'Shipper',
        generalRemark: 'General remarks',
        amendmentReason: 'Amendment reason',
        bookingRequestCancellation: 'Cancellation of Booking Request no. ',
        cancellationConfirmation:
          'Are you sure you want to cancel booking request  no. ',
        cancellationReason: 'Cancellation reason',
        receiverLabels: {
          CMA: 'CMA',
          MAERSK: 'Maersk',
          INTTRA: 'Inttra',
        },
        referenceNumberLabels: {
          QUOTATION: 'Quotation Number',
          CARRIER_RATE_REFERENCE: 'Carrier Rate Reference Number',
          STANDARD_TARIFF: 'Standard Tariff Number',
          BILL_OF_LADING_REFERENCE: 'Bill of Lading Reference Number',
          BOOKING_NUMBER: 'Booking Number',
          CUSTOMER_REFERENCE: 'Customer Reference Number',
          SERVICE_CONTRACT: 'Service Contract Number',
          FORWARDER_REFERENCE: 'Forwarder Reference Number',
          INVOICE_NUMBER: 'Invoice Number',
          SHIPPING_ORDER_NUMBER: 'Shipping Order Number',
          PURCHASE_ORDER: 'Purchase Order',
          SHIPPER_IDENTIFYING: "Shipper's Identifying Number for Shipment",
          CARGOSMART_REFERENCE: 'CargoSmart Reference Number',
          SHIPPER_REFERENCE: 'Shipper reference',
          CONSIGNEE_SHIPMENT_REFERENCE: "Consignee's shipment reference number",
          CONTRACT_PARTY_REFERENCE: 'Contract party reference number',
          MUTUALLY_DEFINED_REFERENCE: 'Mutually defined reference number',
          FREIGHT_TARIFF_REFERENCE: 'Freight tariff number',
          INTTRA_CONTRACT_PARTY_REFERENCE: 'Contract party reference number',
          AGENT_REFERENCE: 'Agent reference number',
          VEHICLE_IDENTIFICATION_NUMBER: 'VIN',
          CONSIGNEES_REFERENCE: "Consignee's reference number",
          EXPORT_LICENCE_REFERENCE: 'Export Licence reference number',
          FREIGHT_FORWARDERS_NUMBER: "Freight forwarder's reference number",
          CONTRACT_LINE_ITEM_NUMBER: "Contract line item's reference number",
          INTTRA_REFERENCE_NUMBER: "INTTRA's reference number",
        },
        partyLabels: {
          CONSIGNEE: 'Consignee',
          FORWARDER: 'Forwarder',
        },
        typeOfCargo: 'Type of cargo',
        goodsDescription: 'Goods description',
        handling: 'Handling',
        handlingLabels: {
          OFU: 'Fumigation',
          OOD: 'Stow on deck',
          OSB: 'Stow below deck',
        },
        productGroup: 'Product group',
        containers: 'Containers',
        temperature: 'Temperature',
        measurements: 'Measurements',
        dimensions: 'Dimensions',
        instructionLabels: {
          HANDLING_INSTRUCTIONS: 'Handling instructions',
          CONTAINER_ATMOSPHERE: 'Container atmosphere',
          CO2_PERCENTAGE: 'CO2 percentage',
          O2_PERCENTAGE: 'O2 percentage',
          SENSETIVE_CARGO: 'Sensetive cargo',
          HUMIDITY_PERCENTAGE: 'De-humidity percentage',
          PRE_COOLING: 'Pre-cooling',
          GENERATOR_SET: 'Generator set',
        },
        instructions: 'Instructions',
        packingGroupLabels: {
          I: 'Minor danger',
          II: 'Medium danger',
          III: 'Great danger',
          GREAT_DANGER: 'Great danger',
          MEDIUM_DANGER: 'Medium danger',
          MINOR_DANGER: 'Minor danger',
        },
        packingGroup: 'Packing group',
        remarks: 'Additional remarks',
        imdg: 'Dangerous goods informations',
        remarksLabels: {
          REMARKS_OF_WHOLE_BOOKING: 'Remarks of whole booking',
          EXPORT_DECLARATION: 'Export Declaration (Canada)',
          REEFER_CARGO_INBOUND_CONTACT: 'Reefer cargo inbound contact',
          REEFER_OUTBOUND_CONTACT: 'Reefer outbound contact',
          REEFER_REMARKS: 'Reefer remarks',
          CUSTOMS_CLEARANCE_INSTRUCTIONS: 'Customs clearance',
          CUSTOMS_DECLARATION_INFORMATION: 'Customs declaration',
        },
        remarksValueCode: {
          CUSTOMER_TO_PERFORM_AMS_FILING: 'Customer to perform ams filing',
          CANADIAN_CARGO_CONTROL_NUMBER: 'Canadian cargo control number',
          NVOCC_SCAC: 'NVOCC SCAC',
          CUSTOMS_EXPORT_DECLARATION_UNIQUE_CONSIGNMENT_REFERENCE:
            'Customs export declaration unique consignment reference',
        },
        customsClearanceInstructionsValueCodeLabel:
          'Customs clearance instructions type',
        customsDeclarationInformationValueCodeLabel:
          'Customs declaration information type',
        customValidation: {
          carriageCondition: 'Please choose carriage condition.',
          seaportMissing: 'Please fill in seaport code value in port table',
        },
        cargoTypeDescription: 'Description regarding cargo type',
        hsCode: 'HS code',
        shippersOwnedContainer: 'Container owner',
        requestedFullPickupDate: 'Requested full pickup date',
        requestedEmptyPositioningDate: 'Requested empty positioning date',
        fieldsValidation: {
          measurementType: 'Cargo Weight must be provided',
          measurementValue: 'Cargo Weight must be provided',
          referenceNumberType:
            'Either Tariff Number or Contract Number must be provided',
          referenceNumber:
            'Either Tariff Number or Contract Number must be provided',
          mutuallyExclusiveReferenceNumbers:
            'Tariff Number and Contract Number cannot be provided at the same time. Please provide only one of the fields',
          requestedEmptyPositioningDate:
            'Requested Empty Positioning Date must be provided when Move Type is either Door to Door or Door to Port',
          requestedFullPickupDate:
            'Requested Full Pick Up Date must be provided when Move Type is either Door to Door or Door to Port',
          shippersOwnedContainer:
            'Container ownership information must be provided',
        },
        shippersOwnedContainerLabels: {
          SHIPPER: 'Shipper',
          CARRIER: 'Carrier',
        },
      },
      shippingInstruction: {
        title: 'Shipping Instruction',
        shippingNumber: 'Shipping Instruction number',
        sendingDate: 'Date of sending',
        generationDate: 'Generation date',
        status: 'Shipping instruction status',
        receiver: 'Receiver',
        bookingNumber: 'Booking number',
        bookingNumberRequired: 'Please enter booking number.',
        carriageConditionRequired: 'Please choose carriage condition.',
        amendmentReason: 'Amendment reason',
        notificationEmailSendNeed: 'I want to receive e-mail notifications',
        updateShippingInstruction: 'Update shipping instruction',
        chargePayment: {
          label: 'Charge payment instructions',
          COLLECT: 'Collect',
          MIXED: 'Mixed',
          PREPAID: 'Prepaid',
        },
        chargeCategory: {
          label: 'Charges category',
          ALL_CHARGES: 'All charges',
          BASIC_FREIGHT: 'Basic freight',
          DESTINATION_HAULAGE_CHARGES: 'Destination haulage charges',
          DESTINATION_PORT_CHARGES: 'Destination port charges',
          ORIGIN_PORT_CHARGES: 'Origin port charges',
          ORIGIN_HAULAGE_CHARGES: 'Origin haulage charges',
          OTHER_CHARGES: 'Other charges',
          ORIGIN: 'Origin',
          DESTINATION: 'Destination',
        },
        chargePaymentRequired: 'Please choose payment instructions.',
        document: 'Document',
        documentType: {
          hint: 'Wybierz typ',
          BILL_OF_LADING: 'Bill of lading',
          BILL_OF_LADING_COPY: 'Bill of lading copy',
          SEA_WAYBILL: 'Sea waybill',
          MARINE_TRANSPORT_DOCUMENT:
            'Non-negotiable maritime transport document (generic) / Express',
          HOUSE_BILL_OF_LADING: 'House bill of lading / Memo BL',
          HOUSE_WAYBILL: 'House waybill',
          BILL_OF_LADING_ORIGINAL: 'Bill of lading original',
        },
        documentStatus: {
          hint: 'Status',
          NOT_FREIGHTED: 'Not freighted',
          FREIGHTED: 'Freighted',
        },
        documentMedium: {
          hint: 'Medium',
          CARGOSMART_ONLINE_BL: 'CargoSmart Online BL',
          EDI_TRANSMISSION: 'EDI transmission',
          ELECTRONIC_MAIL: 'Electronic mail',
          TELEFAX: 'Telefax',
          MAIL_PRINTED_ORIGINAL_REQUIRED: 'Mail (Printed Original Required)',
          OTHERS: 'Others',
        },
        documentCopies: 'Number of copies',
        documentOriginals: 'Number of originals',
        documentName: 'Document name',
        parties: 'Parties',
        partyType: {
          SUBMITTER: 'SI Submitter',
          CARRIER: 'Carrier',
          CONSIGNEE: 'Consignee',
          SHIPPER: 'Shipper',
          FORWARDER: 'Freight forwarder',
          EXPORTER: 'Exporter',
          GOODS_OWNER: 'Goods owner',
          NOTIFY_PARTY_1: 'Notify party no. 1',
          NOTIFY_PARTY_2: 'Notify party no. 2',
          NOTIFY_PARTY_3: 'Notify party no. 3',
        },
        party: 'Party',
        partyName: 'Party name',
        voyage: 'Voyage',
        voyageStage: 'Voyage stage',
        voyageNumber: 'Voyage number',
        vesselName: 'Vessel name',
        governmentReference: 'Government reference number',
        placeOfPickup: 'Place of receipt',
        placeOfLoading: 'Place of loading',
        placeOfDischarge: 'Place of discharge',
        placeOfDelivery: 'Place of delivery',
        inland: 'Inland location',
        goods: 'Cargo details',
        commodity: 'Commodity',
        cargoTypeHint: 'Cargo type',
        cargoTypeLabel: 'Cargo type',
        applyCargoDetails: 'Apply details',
        applyCargoDetailsTo: {
          label: 'Specify and apply to all containers',
          ALL: 'All cargo details',
          PIECES: 'Piece count only',
          DESCRIPTION: 'Cargo description only',
          NONE: 'No, I specify all details at container level',
        },
        packages: 'Packages',
        numberOfPackages: 'Number of packages',
        packageTypeHint: 'Kind of packages',
        packageType: {
          AMPOULE_NON_PROTECTED: 'Ampoule, non-protected',
          AMPOULE_PROTECTED: 'Ampoule, protected',
          BAG: 'Bag',
          BAG_FLEXIBLE_CONTAINER: 'Bag, flexible container',
          BAG_LARGE: 'Bag, large',
          BAG_MULTIPLY: 'Bag, multiply',
          BAG_PAPER: 'Bag, paper',
          BAG_PAPER_MULTI_WALL: 'Bag, paper, multi-wall',
          BAG_PAPER_MULTI_WALL_WATER_RESISTANT:
            'Bag, paper, multi-wall, water resistant',
          BAG_PLASTIC: 'Bag, plastic',
          BAG_PLASTICS_FILM: 'Bag, plastics film',
          BAG_SUPER_BULK: 'Bag, super bulk',
          BAG_TEXTILE: 'Bag, textile',
          BAG_TEXTILE_SIFT_PROOF: 'Bag, textile, sift proof',
          BAG_TEXTILE_WATER_RESISTANT: 'Bag, textile, water resistant',
          BAG_TEXTILE_WITHOUT_INNER_COAT_LINER:
            'Bag, textile, without inner coat/liner',
          BAG_WOVEN_PLASTIC: 'Bag, woven plastic',
          BAG_WOVEN_PLASTIC_SIFT_PROOF: 'Bag, woven plastic, sift proof',
          BAG_WOVEN_PLASTIC_WATER_RESISTANT:
            'Bag, woven plastic, water resistant',
          BAG_WOVEN_PLASTIC_WITHOUT_INNER_COAT_LINER:
            'Bag, woven plastic, without inner coat/liner',
          BALE_COMPRESSED: 'Bale, compressed',
          BALE_NON_COMPRESSED: 'Bale, non-compressed',
          BAR: 'Bar',
          BARREL: 'Barrel',
          BARREL_WOODEN: 'Barrel, wooden',
          BARREL_WOODEN_BUNG_TYPE: 'Barrel, wooden, bung type',
          BARREL_WOODEN_REMOVABLE_HEAD: 'Barrel, wooden, removable head',
          BARS_IN_BUNDLE_BUNCH_TRUSS: 'Bars, in bundle/bunch/truss',
          BASKET: 'Basket',
          BASKET_WITH_HANDLE_CARDBOARD: 'Basket, with handle, cardboard',
          BASKET_WITH_HANDLE_PLASTIC: 'Basket, with handle, plastic',
          BASKET_WITH_HANDLE_WOODEN: 'Basket, with handle, wooden',
          BIN: 'Bin',
          BLOCK: 'Block',
          BOBBIN: 'Bobbin',
          BOTTLECRATE_BOTTLERACK: 'Bottlecrate / bottlerack',
          BOTTLE_GAS: 'Bottle, gas',
          BOTTLE_NON_PROTECTED_BULBOUS: 'Bottle, non-protected, bulbous',
          BOTTLE_NON_PROTECTED_CYLINDRICAL:
            'Bottle, non-protected, cylindrical',
          BOTTLE_PROTECTED_BULBOUS: 'Bottle, protected bulbous',
          BOTTLE_PROTECTED_CYLINDRICAL: 'Bottle, protected cylindrical',
          BOX: 'Box',
          BOX_ALUMINIUM: 'Box, aluminium',
          BOX_COMMONWEALTH_HANDLING_EQUIPMENT_POOLCHEP_EUROBOX:
            'Box, Commonwealth Handling Equipment Pool(CHEP), Eurobox',
          BOX_FIBREBOARD: 'Box, fibreboard',
          BOX_FOR_LIQUIDS: 'Box, for liquids',
          BOX_NATURAL_WOOD: 'Box, natural wood',
          BOX_PLASTIC: 'Box, plastic',
          BOX_PLASTIC_EXPANDED: 'Box, plastic, expanded',
          BOX_PLASTIC_SOLID: 'Box, plastic, solid',
          BOX_PLYWOOD: 'Box, plywood',
          BOX_RECONSTITUTED_WOOD: 'Box, reconstituted wood',
          BOX_STEEL: 'Box, steel',
          BOX_WOODEN_NATURAL_WOOD_ORDINARY:
            'Box, wooden, natural wood, ordinary',
          BOX_WOODEN_NATURAL_WOOD_WITH_SIFT_PROOF_WALLS:
            'Box, wooden, natural wood, with sift proof walls',
          BUCKET: 'Bucket',
          BULK_GAS_AT_1031_MBAR_AND_15C: 'Bulk, gas(at 1031 mbar and 15Â°C)',
          BULK_LIQUEFIED_GAS_AT_ABNORMAL_TEMPERATURE_PRESSURE:
            'Bulk, liquefied gas(at abnormal temperature/pressure)',
          BULK_LIQUID: 'Bulk, liquid',
          BULK_SOLID_FINE_PARTICLES_POWDERS:
            'Bulk, solid, fine particles(â€œpowdersâ€)',
          BULK_SOLID_GRANULAR_PARTICLES_GRAINS:
            'Bulk, solid, granular particles(â€œgrainsâ€)',
          BULK_SOLID_LARGE_PARTICLES_NODULES:
            'Bulk, solid, large particles(â€œnodulesâ€)',
          BUNCH: 'Bunch',
          BUNDLE: 'Bundle',
          CAGE: 'Cage',
          CAGE_COMMONWEALTH_HANDLING_EQUIPMENT_POOLCHEP:
            'Cage, Commonwealth Handling Equipment Pool (CHEP)',
          CAGE_ROLL: 'Cage, roll',
          CANISTER: 'Canister',
          CAN_CYLINDRICAL: 'Can, cylindrical',
          CAN_RECTANGULAR: 'Can, rectangular',
          CAN_WITH_HANDLE_AND_SPOUT: 'Can, with handle and spout',
          CARBOY_NON_PROTECTED: 'Carboy, non-protected',
          CARBOY_PROTECTED: 'Carboy, protected',
          CARTON: 'Carton',
          CASE: 'Case',
          CASE_ISOTHERMIC: 'Case, isothermic',
          CASE_SKELETON: 'Case, skeleton',
          CASE_STEEL: 'Case, steel',
          CASE_WITH_PALLET_BASE: 'Case, with pallet base',
          CASE_WITH_PALLET_BASE_CARDBOARD: 'Case, with pallet base, cardboard',
          CASE_WITH_PALLET_BASE_METAL: 'Case, with pallet base, metal',
          CASE_WITH_PALLET_BASE_PLASTIC: 'Case, with pallet base, plastic',
          CASE_WITH_PALLET_BASE_WOODEN: 'Case, with pallet base, wooden',
          CASK: 'Cask',
          CHEST: 'Chest',
          CHURN: 'Churn',
          COFFER: 'Coffer',
          COFFIN: 'Coffin',
          COIL: 'Coil',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE:
            'Composite packaging, glass receptacle',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_ALUMINIUM_CRATE:
            'Composite packaging, glass receptacle in aluminium crate',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_ALUMINIUM_DRUM:
            'Composite packaging, glass receptacle in aluminium drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_EXPANDABLE_PLASTIC_PACK:
            'Composite packaging, glass receptacle in expandable plastic pack',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_FIBREBOARD_BOX:
            'Composite packaging, glass receptacle in fibreboard box',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_FIBRE_DRUM:
            'Composite packaging, glass receptacle in fibre drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_PLYWOOD_DRUM:
            'Composite packaging, glass receptacle in plywood drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_SOLID_PLASTIC_PACK:
            'Composite packaging, glass receptacle in solid plastic pack',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_STEEL_CRATE_BOX:
            'Composite packaging, glass receptacle in steel crate box',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_STEEL_DRUM:
            'Composite packaging, glass receptacle in steel drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_WICKERWORK_HAMPER:
            'Composite packaging, glass receptacle in wickerwork hamper',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_WOODEN_BOX:
            'Composite packaging, glass receptacle in wooden box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE:
            'Composite packaging, plastic receptacle',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_ALUMINIUM_CRATE:
            'Composite packaging, plastic receptacle in aluminium crate',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_ALUMINIUM_DRUM:
            'Composite packaging, plastic receptacle in aluminium drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_FIBREBOARD_BOX:
            'Composite packaging, plastic receptacle in fibreboard box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_FIBRE_DRUM:
            'Composite packaging, plastic receptacle in fibre drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_PLASTIC_DRUM:
            'Composite packaging, plastic receptacle in plastic drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_PLYWOOD_BOX:
            'Composite packaging, plastic receptacle in plywood box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_PLYWOOD_DRUM:
            'Composite packaging, plastic receptacle in plywood drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_SOLID_PLASTIC_BOX:
            'Composite packaging, plastic receptacle in solid plastic box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_STEEL_CRATE_BOX:
            'Composite packaging, plastic receptacle in steel crate box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_STEEL_DRUM:
            'Composite packaging, plastic receptacle in steel drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_WOODEN_BOX:
            'Composite packaging, plastic receptacle in wooden box',
          CONE: 'Cone',
          CONTAINER_NOT_OTHERWISE_SPECIFIED_AS_TRANSPORT_EQUIPMENT:
            'Container, not otherwise specified as transport equipment',
          CRATE: 'Crate',
          CRATE_BEER: 'Crate, beer',
          CRATE_BULK_CARDBOARD: 'Crate, bulk, cardboard',
          CRATE_BULK_PLASTIC: 'Crate, bulk, plastic',
          CRATE_BULK_WOODEN: 'Crate, bulk, wooden',
          CRATE_FRAMED: 'Crate, framed',
          CRATE_FRUIT: 'Crate, fruit',
          CRATE_MILK: 'Crate, milk',
          CRATE_MULTIPLE_LAYER_CARDBOARD: 'Crate, multiple layer, cardboard',
          CRATE_MULTIPLE_LAYER_PLASTIC: 'Crate, multiple layer, plastic',
          CRATE_MULTIPLE_LAYER_WOODEN: 'Crate, multiple layer, wooden',
          CRATE_SHALLOW: 'Crate, shallow',
          CREEL: 'Creel',
          CYLINDER: 'Cylinder',
          DRUM: 'Drum',
          DRUM_ALUMINIUM: 'Drum, aluminium',
          DRUM_ALUMINIUM_NON_REMOVABLE_HEAD:
            'Drum, aluminium, non-removable head',
          DRUM_ALUMINIUM_REMOVABLE_HEAD: 'Drum, aluminium, removable head',
          DRUM_FIBRE: 'Drum, fibre',
          DRUM_IRON: 'Drum, iron',
          DRUM_PLASTIC: 'Drum, plastic',
          DRUM_PLASTIC_NON_REMOVABLE_HEAD: 'Drum, plastic, non-removable head',
          DRUM_PLASTIC_REMOVABLE_HEAD: 'Drum, plastic, removable head',
          DRUM_PLYWOOD: 'Drum, plywood',
          DRUM_STEEL: 'Drum, steel',
          DRUM_STEEL_NON_REMOVABLE_HEAD: 'Drum, steel, non-removable head',
          DRUM_STEEL_REMOVABLE_HEAD: 'Drum, steel, removable head',
          DRUM_WOODEN: 'Drum, wooden',
          ENVELOPE: 'Envelope',
          ENVELOPE_STEEL: 'Envelope, steel',
          FILMPACK: 'Filmpack',
          FLASK: 'Flask',
          FRAME: 'Frame',
          HAMPER: 'Hamper',
          HOGSHEAD: 'Hogshead',
          INTERMEDIATE_BULK_CONTAINER: 'Intermediate bulk container',
          INTERMEDIATE_BULK_CONTAINER_ALUMINIUM:
            'Intermediate bulk container, aluminium',
          INTERMEDIATE_BULK_CONTAINER_ALUMINIUM_LIQUID:
            'Intermediate bulk container, aluminium, liquid',
          INTERMEDIATE_BULK_CONTAINER_ALUMINIUM_PRESSURISED_10_KPA:
            'Intermediate bulk container, aluminium, pressurised > 10 kpa',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE:
            'Intermediate bulk container, composite',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_FLEXIBLE_PLASTIC_LIQUIDS:
            'Intermediate bulk container, composite, flexible plastic, liquids',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_FLEXIBLE_PLASTIC_PRESSURISED:
            'Intermediate bulk container, composite, flexible plastic, pressurised',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_FLEXIBLE_PLASTIC_SOLIDS:
            'Intermediate bulk container, composite, flexible plastic, solids',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_RIGID_PLASTIC_LIQUIDS:
            'Intermediate bulk container, composite, rigid plastic, liquids',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_RIGID_PLASTIC_PRESSURISED:
            'Intermediate bulk container, composite, rigid plastic, pressurised',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_RIGID_PLASTIC_SOLIDS:
            'Intermediate bulk container, composite, rigid plastic, solids',
          INTERMEDIATE_BULK_CONTAINER_FIBREBOARD:
            'Intermediate bulk container, fibreboard',
          INTERMEDIATE_BULK_CONTAINER_FLEXIBLE:
            'Intermediate bulk container, flexible',
          INTERMEDIATE_BULK_CONTAINER_METAL:
            'Intermediate bulk container, metal',
          INTERMEDIATE_BULK_CONTAINER_METAL_LIQUID:
            'Intermediate bulk container, metal, liquid',
          INTERMEDIATE_BULK_CONTAINER_METAL_OTHER_THAN_STEEL:
            'Intermediate bulk container, metal, other than steel',
          INTERMEDIATE_BULK_CONTAINER_METAL_PRESSURE_10_KPA:
            'Intermediate bulk container, metal, pressure 10 kpa',
          INTERMEDIATE_BULK_CONTAINER_NATURAL_WOOD:
            'Intermediate bulk container, natural wood',
          INTERMEDIATE_BULK_CONTAINER_NATURAL_WOOD_WITH_INNER_LINER:
            'Intermediate bulk container, natural wood, with inner liner',
          INTERMEDIATE_BULK_CONTAINER_PAPER_MULTI_WALL:
            'Intermediate bulk container, paper, multi-wall',
          INTERMEDIATE_BULK_CONTAINER_PAPER_MULTI_WALL_WATER_RESISTANT:
            'Intermediate bulk container, paper, multi-wall, water resistant',
          INTERMEDIATE_BULK_CONTAINER_PLASTIC_FILM:
            'Intermediate bulk container, plastic film',
          INTERMEDIATE_BULK_CONTAINER_PLYWOOD:
            'Intermediate bulk container, plywood',
          INTERMEDIATE_BULK_CONTAINER_PLYWOOD_WITH_INNER_LINER:
            'Intermediate bulk container, plywood, with inner liner',
          INTERMEDIATE_BULK_CONTAINER_RECONSTITUTED_WOOD:
            'Intermediate bulk container, reconstituted wood',
          INTERMEDIATE_BULK_CONTAINER_RECONSTITUTED_WOOD_WITH_INNER_LINER:
            'Intermediate bulk container, reconstituted wood, with inner liner',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC:
            'Intermediate bulk container, rigid plastic',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_FREESTANDING_LIQUIDS:
            'Intermediate bulk container, rigid plastic, freestanding, liquids',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_FREESTANDING_PRESSURISED:
            'Intermediate bulk container, rigid plastic, freestanding, pressurised',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_FREESTANDING_SOLIDS:
            'Intermediate bulk container, rigid plastic, freestanding, solids',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_WITH_STRUCTURAL_EQUIPMENT_LIQUIDS:
            'Intermediate bulk container, rigid plastic, with structural equipment, liquids',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_WITH_STRUCTURAL_EQUIPMENT_PRESSURISED:
            'Intermediate bulk container, rigid plastic, with structural equipment, pressurised',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_WITH_STRUCTURAL_EQUIPMENT_SOLIDS:
            'Intermediate bulk container, rigid plastic, with structural equipment, solids',
          INTERMEDIATE_BULK_CONTAINER_STEEL:
            'Intermediate bulk container, steel',
          INTERMEDIATE_BULK_CONTAINER_STEEL_LIQUID:
            'Intermediate bulk container, steel, liquid',
          INTERMEDIATE_BULK_CONTAINER_STEEL_PRESSURISED_10_KPA:
            'Intermediate bulk container, steel, pressurised > 10 kpa',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_COATED:
            'Intermediate bulk container, textile, coated',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_COATED_AND_LINER:
            'Intermediate bulk container, textile, coated and liner',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_WITH_LINER:
            'Intermediate bulk container, textile, with liner',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_WITH_OUT_COAT_LINER:
            'Intermediate bulk container, textile with out coat/liner',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_COATED:
            'Intermediate bulk container, woven plastic, coated',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_COATED_AND_LINER:
            'Intermediate bulk container, woven plastic, coated and liner',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_WITHOUT_COAT_LINER:
            'Intermediate bulk container, woven plastic, without coat/liner',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_WITH_LINER:
            'Intermediate bulk container, woven plastic, with liner',
          JAR: 'Jar',
          JERRICAN_CYLINDRICAL: 'Jerrican, cylindrical',
          JERRICAN_PLASTIC: 'Jerrican, plastic',
          JERRICAN_PLASTIC_NON_REMOVABLE_HEAD:
            'Jerrican, plastic, non-removable head',
          JERRICAN_PLASTIC_REMOVABLE_HEAD: 'Jerrican, plastic, removable head',
          JERRICAN_RECTANGULAR: 'Jerrican, rectangular',
          JERRICAN_STEEL: 'Jerrican, steel',
          JERRICAN_STEEL_NON_REMOVABLE_HEAD:
            'Jerrican, steel, non-removable head',
          JERRICAN_STEEL_REMOVABLE_HEAD: 'Jerrican, steel, removable head',
          JUG: 'Jug',
          JUTEBAG: 'Jutebag',
          KEG: 'Keg',
          LIFTVAN: 'Liftvan',
          MUTUALLY_DEFINED: 'Mutually defined',
          NEST: 'Nest',
          NET: 'Net',
          NET_TUBE_PLASTIC: 'Net, tube, plastic',
          NET_TUBE_TEXTILE: 'Net, tube, textile',
          PACKAGE: 'Package',
          PACKAGE_CARDBOARD_WITH_BOTTLE_GRIP_HOLES:
            'Package, cardboard, with bottle grip-holes',
          PACKAGE_DISPLAY_CARDBOARD: 'Package, display, cardboard',
          PACKAGE_DISPLAY_METAL: 'Package, display, metal',
          PACKAGE_DISPLAY_PLASTIC: 'Package, display, plastic',
          PACKAGE_DISPLAY_WOODEN: 'Package, display, wooden',
          PACKAGE_FLOW: 'Package, flow',
          PACKAGE_PAPER_WRAPPED: 'Package, paper wrapped',
          PACKAGE_SHOW: 'Package, show',
          PACKET: 'Packet',
          PAIL: 'Pail',
          PALLET: 'Pallet',
          PALLET_100CMS_110CMS: 'Pallet, 100cms * 110cms',
          PALLET_BOX_COMBINED_OPEN_ENDED_BOX_AND_PALLET:
            'Pallet, box Combined open-ended box and pallet',
          PALLET_MODULAR_COLLARS_80CMS_100CMS:
            'Pallet, modular, collars 80cms * 100cms',
          PALLET_MODULAR_COLLARS_80CMS_120CMS:
            'Pallet, modular, collars 80cms * 120cms',
          PALLET_MODULAR_COLLARS_80CMS_60CMS:
            'Pallet, modular, collars 80cms * 60cms',
          PALLET_SHRINKWRAPPED: 'Pallet, shrinkwrapped',
          PIECE: 'Piece',
          PIPE: 'Pipe',
          PIPES_IN_BUNDLE_BUNCH_TRUSS: 'Pipes, in bundle/bunch/truss',
          PITCHER: 'Pitcher',
          POT: 'Pot',
          POUCH: 'Pouch',
          RACK: 'Rack',
          RACK_CLOTHING_HANGER: 'Rack, clothing hanger',
          RECEPTACLE_FIBRE: 'Receptacle, fibre',
          RECEPTACLE_GLASS: 'Receptacle, glass',
          RECEPTACLE_METAL: 'Receptacle, metal',
          RECEPTACLE_PAPER: 'Receptacle, paper',
          RECEPTACLE_PLASTIC: 'Receptacle, plastic',
          RECEPTACLE_PLASTIC_WRAPPED: 'Receptacle, plastic wrapped',
          RECEPTACLE_WOODEN: 'Receptacle, wooden',
          REEL: 'Reel',
          RING: 'Ring',
          ROLL: 'Roll',
          SACHET: 'Sachet',
          SACK: 'Sack',
          SACK_MULTI_WALL: 'Sack, multi-wall',
          SEA_CHEST: 'Sea-chest',
          SET: 'Set',
          SHEET: 'Sheet',
          SHEETS_IN_BUNDLE_BUNCH_TRUSS: 'Sheets, in bundle/bunch/truss',
          SHEET_PLASTIC_WRAPPING: 'Sheet, plastic wrapping',
          SHRINKWRAPPED: 'Shrinkwrapped',
          SKID: 'Skid',
          SPINDLE: 'Spindle',
          SPOOL: 'Spool',
          TANK_CYLINDRICAL: 'Tank, cylindrical',
          TANK_RECTANGULAR: 'Tank, rectangular',
          TIN: 'Tin',
          TRAY: 'Tray',
          TRAY_CONTAINING_HORIZONTALLY_STACKED_FLAT_ITEMS:
            'Tray, containing horizontally stacked flat items',
          TRAY_ONE_LAYER_NO_COVER_CARDBOARD:
            'Tray, one layer no cover, cardboard',
          TRAY_ONE_LAYER_NO_COVER_PLASTIC: 'Tray, one layer no cover, plastic',
          TRAY_ONE_LAYER_NO_COVER_POLYSTYRENE:
            'Tray, one layer no cover, polystyrene',
          TRAY_ONE_LAYER_NO_COVER_WOODEN: 'Tray, one layer no cover, wooden',
          TRAY_RIGID_LIDDED_STACKABLE_CEN_TS_14482_2002:
            'Tray, rigid, lidded stackable(CEN TS 14482:2002)',
          TRAY_TWO_LAYERS_NO_COVER_CARDBOARD:
            'Tray, two layers no cover, cardboard',
          TRAY_TWO_LAYERS_NO_COVER_PLASTIC_TRAY:
            'Tray, two layers no cover, plastic tray',
          TRAY_TWO_LAYERS_NO_COVER_WOODEN: 'Tray, two layers no cover, wooden',
          TRUNK: 'Trunk',
          TRUSS: 'Truss',
          TUB: 'Tub',
          TUBE: 'Tube',
          TUBES_IN_BUNDLE_BUNCH_TRUSS: 'Tubes, in bundle/bunch/truss',
          TUBE_COLLAPSIBLE: 'Tube, collapsible',
          TUBE_WITH_NOZZLE: 'Tube, with nozzle',
          TUB_WITH_LID: 'Tub, with lid',
          TUN: 'Tun',
          UNIT: 'Unit',
          UNPACKED_OR_UNPACKAGED: 'Unpacked or unpackaged',
          UNPACKED_OR_UNPACKAGED_MULTIPLE_UNITS:
            'Unpacked or unpackaged, multiple units',
          UNPACKED_OR_UNPACKAGED_SINGLE_UNIT:
            'Unpacked or unpackaged, single unit',
          VANPACK: 'Vanpack',
          VAT: 'Vat',
          VEHICLE: 'Vehicle',
          VIAL: 'Vial',
        },
        grossWeight: 'Weight (kg)',
        grossVolume: 'Volume (m^3)',
        cargoDescription: 'Cargo description',
        dimensions: 'Dimensions',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        dimensionUnit: 'Unit',
        hsCode: 'HS code',
        IMDGCode: 'IMDG code',
        IMOCCodeHint: 'IMO Class',
        IMDGCodeHint: 'Code',
        DGSCode: 'Dangerous goods description',
        DGSName: 'Dangerous goods contact name',
        DGSPhone: 'Dangerous goods contact phone',
        flashpoint: 'Flashpoint',
        temperatureHint: 'Temperature',
        flashUnit: 'Unit',
        packingGroup: 'Packing group',
        shippingMarks: 'Shipping marks',
        containers: 'Container list',
        containerNumberHint: 'Choose container',
        measurements: {
          label: 'Measurements',
          GROSS_WEIGHT: 'Gross weight',
          GROSS_VOLUME: 'Gross volume',
        },
        seals: {
          label: 'Seals',
          issuers: {
            CARRIER: 'Carrier',
            CONSGINEE: 'Consignee',
            CUSTOMS: 'Customs',
            FORWARDER: 'Forwarder',
            HIGH_SECURITY: 'High Security',
            MOTOR_CARRIER: 'Motor Carrier',
            NOTIFY_PARTY: 'Notify Party',
            QUARANTINE_AGENCY: 'Quarantine agency',
            RAILROAD: 'Railroad',
            SHIPPER: 'Shipper',
            TERMINAL_OPERATOR: 'Terminal operator',
            VET_SEAL: 'Vet Seal',
            MUTUALLY_DEFINED: 'Mutually Defined',
          },
        },
        sealIssuerHint: 'Seal issuer',
        sealNumberHint: 'Seal number',
        temperature: 'Temperature',
        additionalInformation: 'Additional information',
        total: 'Total',
        totalGrossWeight: 'Total gross weight',
        totalConsignment: 'Total consignment, cube',
        totalPackages: 'Total number of packages',
        totalEquipment: 'Total number of equipment',
        remarks: 'Remarks, Clauses',
        remarkCodes: {
          hint: 'Choose code',
          DO_NOT_PRINT_ANY_CHARGES_IN_BL: 'Do not print any charges in B/L',
          SHIPPERS_LOAD_AND_COUNT: "Shipper's Load and Count",
          SHIPPERS_LOAD_STOWAGE_AND_COUNT: "Shipper's Load, Stowage and Count",
          LADEN_ON_BOARD: 'Laden on Board',
          LADEN_ON_BOARD_VESSEL: 'Laden on Board Vessel',
          VESSEL_NOT_RESPONSIBLE_FOR_FREEZING:
            'Vessel Not Responsible for Freezing',
          CONTAINER_SEALED_BY_SHIPPER: 'Container(s) Sealed by Shipper',
          ON_DECK_AT_SHIPPERS_RISK: "On Deck at Shipper's Risk",
          SHORT_SHIPPED: 'Short-Shipped',
          SEA_WAYBILL: 'Sea Waybill',
          THIS_SHIPMENT_IS_EFFECTED_UNDER_A_SEA_WAYBILL:
            'This Shipment is Effected under a Sea Waybill',
          MEMO_BILL_OF_LADING_ONLY: 'Memo Bill of Lading Only',
          REFRIGERATED_CARGO: 'Refrigerated Cargo',
          COOL_CARGO: 'Cool Cargo',
          FREEZE_CARGO: 'Freeze Cargo',
          INLAND_TRANSPORTATION_ARRANGED_AS_AGENTS:
            'Inland Transportation Arranged as Agents Only with such Arranged Transportation Being Solely for Account and Risk of Cargo',
          SEA_AIR_CARGO: 'Sea-Air Cargo',
          FREIGHT_PREPAID: 'Freight Prepaid',
          FREIGHT_COLLECT: 'Freight Collect',
          FREIGHT_AS_AGREED: 'Freight as Agreed',
          NO_SHIPPERS_EXPORT_DECLARATION_REQUIRED:
            "No Shipper's Export Declaration Required (Section 30.39)",
          CARRIER_HEATED_WAREHOUSE_AT_COST:
            'Carrier Reserves the Right to Place Container(s) in Heated Warehouse at a Set Cost',
          ON_BOARD_RAIL: 'On Board Rail',
          ON_BOARD_TRUCK: 'On Board Truck',
          ON_BOARD_VESSEL: 'On Board Vessel',
          RECEIVED_FOR_SHIPMENT: 'Received For Shipment',
          ON_BOARD_CONTAINER: 'On Board Container',
          EMERGENCY_RESPONSE_STATEMENT: 'Emergency Response Statement',
          INTERNATIONAL_MARITIME_ORGANIZATION_CERTIFICATION:
            'International Maritime Organization Certification',
          DESTINATION_CONTROL_STATEMENTS: 'Destination Control Statements',
          PRODUCING_COUNTRY_OF_ORIGIN: 'Producing Country of Origin',
          LADEN_ON_BOARD_NAMED_VESSEL: 'Laden on Board Named Vessel',
          AGE_OF_VESSEL: 'Age of Vessel',
          CERTIFICATION_STATEMENTS: 'Certification Statements',
          DESTINATION_COUNTRY: 'Destination Country',
          TITLE_PASSAGE_CLAUSE: 'Title Passage Clause',
          CONTAINER_SAFETY_ACT: 'Container Safety Act',
          GENERAL_AGREEMENT_ON_TARIFF_AND_TRADE:
            'General Agreement on Tariff and Trade (GATT)',
          PRIOR_DAMAGE_REMARKS: 'Prior Damage Remarks',
          ADMINISTRATIVE: 'Administrative',
          CARIBBEAN_BASIN_INITIATIVE: 'Caribbean Basin Initiative (CBI)',
          CUSTOM: 'Custom',
          CONTAINER_PACKING_CERTIFICATE: 'Container Packing Certificate',
          DISCLAIMER: 'Disclaimer',
          DELIVERY_ORDER_LIABILITY_CLAUSE: 'Delivery Order Liability Clause',
          ESTIMATE_ERROR: 'Estimate Error',
          ESTIMATE_REMARKS: 'Estimate Remarks',
          GENERAL_SYSTEM_OF_PREFERENCES: 'General System of Preferences (GSP)',
          HEADING: 'Heading',
          HIDDEN: 'Hidden',
          ISRAELI_FREE_TRADE_AGREEMENT: 'Israeli Free Trade Agreement',
          NORTH_AMERICAN_FREE_TRADE_AGREEMENT:
            'North American Free Trade Agreement (NAFTA)',
        },
        BLRemarks: 'Bill of lading remarks',
        BLClauses: 'Bill of lading clauses',
        specialInstructions: 'Special instructions',
        alert: {
          messageSent:
            'Shipping instruction number {documentNumber}/SI/{updateCounter} sent to the carrier.',
          messageNotSent:
            'Shipping instruction number {documentNumber}/SI/{updateCounter} was not sent to the carrier.',
        },
        measurementValue: 'Invalid value',
      },
      bookingConfirmation: {
        title: 'Booking Confirmation',
        carrier: 'Carrier',
        bookingParty: 'Booking party',
        shipperParty: 'Shipper',
        consigneeParty: 'Consignee',
        forwarderParty: 'Forwarder',
        containers: 'Containers',
        bookingNumber: 'Booking number',
        inttraReference: 'Inttra ref.',
        bookingConfirmationStatus: 'Booking Confirmation status',
        category: 'Category',
        shippingInstructionsCutoff: 'Shipping Instructions cutoff',
        vgmCutoff: 'VGM cutoff',
        generalInformation: 'General information',
        status: {
          CONFIRMED: 'confirmed',
          CANCELLED: 'Cancelled',
          REJECTED_BY_CARRIER: 'Rejected by Carrier',
          UPDATED: 'Last updated on ',
        },
        categoryLabels: {
          LCLLCL: 'LCL/LCL',
          FCLFCL: 'FCL/FCL',
          FCLLCL: 'FCL/LCL',
          LCLFCL: 'LCL/FCL',
        },
        transportStagesHeader: 'Transport stages',
        transportStageQualifier: {
          PRE_CARRIAGE_TRANSPORT: 'Pre-carriage transport',
          MAIN_CARRIAGE_TRANSPORT: 'Main carriage (first)',
          MAIN_CARRIAGE_TRANSPORT_SECOND: 'Main carriage (second)',
          MAIN_CARRIAGE_TRANSPORT_THIRD: 'Main carriage (third)',
          MAIN_CARRIAGE_TRANSPORT_FOURTH: 'Main carriage (fourth)',
          MAIN_CARRIAGE_TRANSPORT_FIFTH: 'Main carriage (fifth)',
          ON_CARRIAGE_TRANSPORT: 'On-carriage transport',
        },
        transportStage: {
          ordinalNumber: 'Transport stage',
          qualifier: 'Transport stage qualifier',
          voyageNumber: 'Voyage number',
          carrier: 'Carrier',
          transportId: 'Transport ID',
          vesselName: 'Vessel name',
          placeOfPickup: 'Place of pick-up',
          cutOffDate: 'Cut-off',
          pickupDate: 'Pick-up date',
          placeOfLoading: 'Place of loading',
          etd: 'ETD',
          placeOfDischarge: 'Place of discharge',
          eta: 'ETA',
          placeOfDelivery: 'Place of delivery',
          deliveryDate: 'Delivery date',
        },
        bookingPartiesHeader: 'Booking parties',
        goodsDescription: 'Goods description',
        cargoType: 'Cargo type',
        containersHeader: 'Containers',
        containerSupplier: {
          Carrier: 'Carrier supplied',
          Shipper: 'Shipper supplied',
        },
        latestDeliveryDate: 'Cutoff',
        emptyContainerPickupLocation: 'Empty container pickup location',
        fullContainerDropOffLocation: 'Full container dropoff location',
      },
      verificationOfMass: {
        showModalButton: 'Weight declaration',
        missingBookingNumber: 'Please enter booking number to declare weight.',
        contactOperatorToDeclareWeight:
          'Contact the forwarder to declare weight.',
        missingContainerNumber:
          'Please enter container number to declare weight.',
        header: 'Container verified gross mass declaration',
        warning:
          'I declare that VGM is specified according to SOLAS Convention regulations.',
        shipper: 'Shipper',
        personResponsible: 'Responsible person',
        containerWeight: 'Container weight (kg)',
        verificationDate: 'Verification date',
        verificationMethods: {
          label: 'Verification method',
          method1: 'Weighing the container (SM1)',
          method2: 'Weighing all packages (SM2)',
          hint:
            'Method 1 (SM1) – weighing the container using calibrated and certified weighing equipment' +
            ' (COPARN definition EGW=Gross Weight (including transport unit)\n' +
            'Method 2 (SM2) – weighing all packages, cargo items, pallets, dunnage and other securing material and adding the tare' +
            ' (COPARN definition Option G+T where G=Gross weight (excluding transport unit) and T=Tare weight (transport unit))',
        },
        messageSent: 'Verified gross mass for {containers} sent to the carrier',
        messageNotSent:
          'Verified gross mass for {containers} was not sent to the carrier',
      },
    },
  },
  counterparty: {
    counterparty: 'Counterparty',
    details: 'Counterparty details',
    name: 'Name',
    code: 'Short name',
    description: 'Description',
    tradeKeepers: 'Trading Keepers',
    taxTypes: {
      NIP: 'NIP',
      VATIN: 'VATIN',
      OTHER: 'Other',
    },
    cad: 'CAD',
    nip: 'NIP',
    regon: 'REGON',
    krs: 'KRS',
    TaxIdentificator: 'Tax identificator',
    IdentificatorCode: 'Identificator code',
    data: 'Counterparty data',
    businessCards: 'Business cards',
    addBusinessCard: 'Add business card',
    accounts: 'Accounts',
    addAccount: 'Add account',
    EU: 'EU',
    defaultInvoiceClass: 'Default invoice type',
    redirectToActivityList: 'Redirect to the entire list of activities',
    tabs: {
      general: 'Information',
      files: 'Files',
      upcoming: 'Upcoming activities',
      latest: 'Latest activities',
      serviceTerms: 'Service Terms',
    },
    files: {
      name: 'Name',
      label: 'Label',
      creationDate: 'Creation date',
      createFile: 'Create a file',
      createServiceTermsFile: 'Add service terms file',
      serviceTermFilesNotSet: "Service terms file for counterparty wasn't set.",
    },
  },
  businessFunctions: {
    functions: {
      Trucker: 'Trucker',
      Customer: 'Customer',
      CustomsAgency: 'Customs Agency',
      Insurer: 'Insurer',
      Depot: 'Depot',
      ShippingLine: 'Shipping Line',
      Terminal: 'Terminal',
      Other: 'Other',
      Agent: 'Agent',
    },
    trucker: {
      sectionName: 'Trucker',
      licenseExpiration: 'License expiration',
      insuranceExpiration: 'Insurance expiration',
      insuranceAmount: 'Insurance amount',
    },
    customer: {
      sectionName: 'Customer',
      jobKeepers: 'Job Keepers',
      storehouses: 'Storehouses',
      addStorehouse: 'Add storehouse',
      dueDays: 'Due days',
      defaultCurrency: 'Default currency',
      defaultProductGroup: 'Product group',
      editStorehouses: 'Edit storehouses',
      saveStoreHouses: 'Save storehouses',
    },
    customsAgency: {
      sectionName: 'Customs Agency',
    },
    insurer: {
      sectionName: 'Insurer',
    },
    depot: {
      sectionName: 'Depot',
      addLot: 'Add lot',
      port: 'Port',
      editLots: 'Edit lots',
      saveLots: 'Save lots',
    },
    shippingline: {
      sectionName: 'Shipping Line',
      scac: 'SCAC',
      contractNumber: 'Contract number',
    },
    terminal: {
      sectionName: 'Terminal',
      port: 'Port',
    },
    other: {
      sectionName: 'Other',
    },
    agent: {
      sectionName: 'Agent',
    },
  },
  user: {
    details: 'User details',
    data: 'User data',
    name: 'Name',
    login: 'Login',
    phone: 'Phone',
    email: 'E-mail',
    role: 'Role',
    account: 'Account status',
    enabled: 'Enabled',
    locked: 'Locked',
    accountExpired: 'Account expiration date',
    credentialsExpired: 'Credentials expired',
    memberships: 'Memberships',
    permissions: {
      sectionName: 'Permissions',
      group: 'Role group',
      roles: 'Roles',
    },
    branch: 'Branch',
    currentPassword: 'Current password',
    password: 'Password',
    passwordRepeat: 'Repeat password',
    passwordsDontMatch: 'Passwords do not match',
    emailCredentials: 'Email settings',
    emailLogin: 'Email login',
    emailPassword: 'Email password',
    emailCredentialsChanged: 'Email settings changed successfully',
    replacements: 'Replacements',
    clientPanel: 'Client Panel User',
    customer: 'Customer',
    acceptedBothAcceptances: 'RODO clauses accepted',
  },
  resource: {
    labels: {
      OFFER_TEMPLATE: 'Offer printout template',
      INVOICE_TEMPLATE: 'Invoice printout template',
    },
    lastModifiedTime: 'Modification date',
    creationTime: 'Creation date',
    size: 'File size',
  },
  parameter: {
    labels: {
      DEFAULT_EXCHANGE_RATE_SOURCE: 'Default exchange rate source',
      PRIMARY_CURRENCY_CODE: 'Primary currency',
      PRIMARY_COUNTERPARTY_CODE: 'Primary counterparty',
      TRUCKER_LICENSE_EXPIRED_MESSAGE: 'Trucker license expired message',
      TRUCKER_INSURANCE_EXPIRED_MESSAGE: 'Trucker insurance expired message',
      OFFER_CODE_FORMAT: 'Offers numbering format',
      JOB_CODE_FORMAT: 'Jobs numbering format',
      WAYBILL_CODE_GENERATOR: 'Waybills numbering format',
      INVOICE_CODE_GENERATOR: 'Invoices numbering format',
      CORRECTIVE_INVOICE_CODE_GENERATOR: 'Corrective invoices numbering format',
      NO_VAT_INVOICE_CODE_GENERATOR: 'NV Invoices numbering format',
      NO_VAT_CORRECTIVE_INVOICE_CODE_GENERATOR:
        'NV Corrective invoices numbering format',
      PRIMARY_CONTROLLER: 'Primary controller',
      USER_PASSWORD_EXPIRE_DAYS: 'User password expire days',
      ORDER_CODE_GENERATOR: 'Orders code format',
      REQUEST_FOR_OFFER_CODE_FORMAT: 'Request for offer code format',
      SHIPPING_INSTRUCTION_CODE_FORMAT: 'Shipping instruction code format',
      BOOKING_REQUEST_CODE_FORMAT: 'Booking request code format',
      DEFAULT_TAX_RATE: 'Default tax rate',
      LAST_CONSECUTION_RESET_YEAR: 'Year when sequences were last reset',
      ADMINISTRATIVE_INVOICE_CODE_GENERATOR:
        'Administrative invoices numbering format',
      CORRECTIVE_ADMINISTRATIVE_INVOICE_CODE_GENERATOR:
        'Administrative corrective invoices numbering format',
      CUT_OFF_TIME:
        'Show warning about unpublished invoices older than (hours)',
      ALERT_EXPIRE_DAYS:
        'Number of days after which notifications will be removed',
      ARCHIVED_EDI_MESSAGE_DELETE_AFTER_DAYS:
        'Number of days after which archived outgoing EDI messages will be removed',
      PRIMARY_COUNTERPARTY_LOCATION_UNECE_CODE:
        'UNECE code for primary counterparty office location',
    },
    parameter: 'Parameter',
  },
  group: {
    details: 'Group details',
    data: 'Group data',
    roles: 'Group roles',
    code: 'Name',
    description: 'Description',
  },
  branch: {
    path: 'Path',
    parent: 'Parent',
    branches: 'Branches',
  },
  port: {
    details: 'Port details',
    data: 'Port data',
    name: 'Name',
    description: 'Description',
    countryCode: 'Country',
    seaportCode: 'Seaport code',
    main: 'Main',
  },
  currency: {
    currency: 'Currency',
    addCurrency: 'Add currency',
    visible: 'Visible',
  },
  activity: {
    serviceType: 'Service type',
    discriminant: 'Discriminant',
    tradeType: 'Relation',
    name: 'Name',
    addLanguage: 'Add language',
    tradeTypeLabels: {
      IMPORT: 'Import',
      EXPORT: 'Export',
      COUNTRY: 'Country',
    },
    loadType: 'Category',
    granular: 'Granular',
    loadTypeLabels: {
      FCL: 'FCL',
      LCL: 'LCL',
      FTL: 'FTL',
      LTL: 'LTL',
    },
    direct: 'Direct',
    incomeAccount: 'Income account',
    costAccount: 'Cost account',
    billingAccount: 'Billing account',
    transportMeansSell: 'Transport means sell',
  },
  unit: {
    addLanguage: 'Add language',
    name: 'Name',
  },
  clause: {
    initial: 'Use by default',
    document: 'Target document',
    documentLabels: {
      OFFER: 'Offer',
      INVOICE: 'Invoice',
      WAYBILL_EXPORT: 'Waybill - export',
      WAYBILL_IMPORT: 'Waybill - import',
      CONTAINER_ORDER: 'Pickup/discharge order',
      ADMINISTRATIVE_INVOICE: 'Administrative invoice',
      ACCEPTANCE_CONFIRMATION: 'Job acceptance confirmation',
    },
    type: 'Type',
    typeLabels: {
      BODY: 'Clause',
      HEADER: 'Header',
    },
    clause: 'Clause',
    header: 'Headers',
    body: 'Clauses',
    mandatory: 'Mandatory',
    content: 'Content',
    addLanguage: 'Add language',
  },
  messages: {
    statusNotFound: "Object doesn't exist.",
    permissionDenied: "You don't have sufficent rights.",
  },
  admin: {
    account: 'Account',
    users: 'Users',
    groups: 'Groups',
    roles: 'Roles',
    parameters: 'Parameters',
    branches: 'Branches',
    ports: 'Ports',
    units: 'Units',
    activities: 'Activities',
    currencies: 'Currency Codes',
    productGroups: 'Product Groups',
    terminalPrices: 'Terminals Prices',
    customsAgencyPrices: 'Customs Agencies Prices',
    transportPrices: 'Transport Prices',
    transportRates: 'Transport Rates',
    exchangeRates: 'Exchange Rates',
    taxRates: 'VAT Rates',
    packages: 'Packages',
    clauses: 'Clauses',
    distances: 'Distances',
    itemConfigurations: 'Item Configurations',
    containerSizes: 'Container Sizes',
    containerTypes: 'Container Types',
    invoiceClasses: 'Invoice Classes',
    containers: 'Containers',
    regions: 'Regions',
    forecasts: 'Forecasts',
    transportModes: 'Modes of Transport',
    ediParties: 'Consignees',
    jpk: 'JPK',
    generateJpk: 'Generate JPK file',
    primaryCounterpartyData: 'Main counterparty data',
    generateJpkSuccess: 'Downloaded files count: {count}',
    serviceTerms: 'Service Terms',
    inttraSupportedLines: 'INTTRA supported shipping lines',
    inttraIntegration: 'Integration with INTTRA',
  },
  superadmin: {
    initialDataLoad: 'Initial data load',
    clearData: 'Delete existing data',
    loadData: 'Load data',
    activityMapping: ' - discriminants',
  },
  tabs: {
    truckers: 'Truckers',
    customers: 'Customers',
    counterparties: 'Counterparties',
    customsagencies: 'Customs Agencies',
    insurers: 'Insurers',
    depots: 'Depots',
    shippinglines: 'Shipping Lines',
    terminals: 'Terminals',
    others: 'Other',
    agents: 'Agents',
  },
  menu: {
    offers: 'Offers',
    jobs: 'Jobs',
    invoices: 'Invoices',
    rates: 'Rates',
    transportCloud: 'Transport cloud',
    reports: 'Reports and forecasts',
    files: 'Files',
    counterparties: 'Counterparties',
    tables: 'Tables',
    prices: 'Prices',
    inbox: 'Inbox',
    administration: 'Administration',
    superadmin: 'Super admin panel',
    account: 'Account',
    logout: 'Logout',
    settings: 'Settings',
    inquiries: 'Requests',
    orders: 'Orders',
    newsletter: 'Newsletter',
    client: 'Client',
    mapping: 'Mapping',
  },
  clientHomePage: {
    notifications: 'Messages',
  },
  homePage: {
    notifications: 'Notifications',
    dashboard: 'Dashboard',
  },
  businessCard: {
    name: 'Name',
    description: 'Description',
    function: 'Position',
    email: 'E-mail',
    phone: 'Phone',
    phone2: 'Mobile',
    fax: 'Fax',
    other: 'Other',
  },
  responsibilities: {
    responsibilities: 'Functions',
    CustomsMessageReceiver: 'Customs messages receiver',
    InvoiceReceiver: 'Invoices receiver',
    OfferReceiver: 'Offers receiver',
    ComplainmentReceiver: 'Complainment receiver',
    Other: 'Other',
  },
  bankAccount: {
    number: 'Number',
    swift: 'SWIFT number',
    bank: 'Bank',
  },
  validation: {
    required: 'This field is required.',
    requiredObjectId: 'This field is required.',
    dualFieldRequired: 'This field is required.',
    min: 'Please enter a value greater than or equal to {{0}}.',
    minFraction: 'Please enter a value greater than or equal to {{0}}.',
    max: 'Please enter a value less than or equal to {{0}}.',
    minLength: 'Please enter at least {{0}} characters.',
    maxLength: 'Please enter no more than {{0}} characters.',
    maxValueLength: 'Please enter no more than {{0}} digits.',
    pattern: 'Please check this value.',
    step: 'The value must increment by {{0}}.',
    email: 'This is not a proper email address.',
    date: 'Please enter a proper date.',
    dateISO: 'Please enter a proper date.',
    number: 'Please enter a number.',
    digit: 'Please enter a digit.',
    phoneUS: 'Please specify a valid phone number.',
    equal: 'Values must be equal.',
    notEqual: 'Please choose another value.',
    unique: 'Please make sure the value is unique.',
    tarpaulinCode: 'Please enter between 5 and 11 characters.',
    containerCode: 'Code must conform to ISO6346.',
    greaterThan: 'Please enter a value greater than {{0}}.',
    ISO6346: 'Code must conform to ISO6346.',
    noPastDates: 'Please enter date from the future.',
    filename:
      'File name may not contain \\ / : * ? " < > | # characters or start with a dot.',
    minGross: 'Gross value must be greater than or equals to {{0}}.',
    minWeight: 'Gross weight must be equal or greater than Net weight.',
    integer: 'Please enter an integer.',
    VATINNumber: 'Please enter valid number.',
    lengthObservable: 'Please enter exactly {0} characters.',
    uploadField: 'Attach file.',
    withoutLetters: 'Please enter value without any letters.',
    bigDecimal: 'Please enter number smaller than 10^17.',
    minArrayLength: 'Please select at least {0} values.',
    notBeforeDependentDate: 'Please enter date after {{0}}.',
    notBeforeDateAsync: 'Please enter date after {{0}}.',
    notAfterDependentDate: 'Please enter date before {{0}}.',
    notEqualTo: 'Please enter value not equal to {{0}}.',
    allocation: 'The value od allocation cannot exceed the value of {0}.',
    noFutureDates: 'Please enter date from the past.',
    entryContainerTypeMismatch:
      'Warning! You have selected services relating to different size of containers.',
    itemContainerTypeMismatch:
      'Warning! You have selected loads with a different size/type than that declared in the service.',
    exchangeRateDate: 'has not been found.',
    exchangeRateExistsAsync: 'No exchange rate for {0} found from {1}.',
    allInUnitMismatch: 'Warning! You have chosen items for different units.',
    REGONNumber: 'Please enter valid regon.',
    postalCode: 'Please enter valid postal code.',
    toFirstDayOfCurrentMonth: 'before the first day of current month',
    hasDuplicates: 'This value has a duplicate.',
    IBAN: 'Please enter valid IBAN code',
    SWIFT: 'Please enter valid SWIFT code',
    correctedInvoiceSelectedValidator: 'Select existing invoice',
    allInMarkupChanged: 'Warning! Markup recalculated.',
  },
  datagrid: {
    of: 'of',
    placeholder: 'Search',
    perPage: 'per page',
    entriesPerPage: 'Entries per page',
  },
  priceItem: {
    customsAgency: 'Customs agency',
    terminal: 'Terminal',
    transport: 'Transport',
    currency: 'Currency',
    netAmount: 'Net amount',
    grossAmount: 'Gross amount',
    markup: 'Markup',
    effectiveDate: 'Effective Date',
    activity: 'Activity',
    containerSize: 'Container size',
    containerType: 'Container type',
    fromLocation: 'From',
    toLocation: 'To',
    distance: 'Distance',
    country: 'Country',
  },
  distance: {
    from: 'From',
    to: 'To',
    country: 'Country',
    distance: 'Distance (km)',
    isNotUnique: 'This distance is not unique',
  },
  transportRate: {
    from: 'From (km)',
    to: 'To (km)',
    isOverlapping: 'Distances are overlapping with other records',
  },
  invoice: {
    invoice: 'Invoice',
    ownTab: 'Own',
    foreignTab: 'Foreign',
    administrativeTab: 'Administrative',
    internalTab: 'Internal',
    own: 'Own',
    correctiveInvoice: 'Corrective invoice',
    forInvoice: 'For invoice',
    was: 'Was',
    shouldBe: 'Should be',
    issueDate: 'Issue date',
    saleDate: 'Sale date',
    dueDate: 'Due date',
    receiptDate: 'Receipt date',
    exchangeRateDate: 'Exchange rate from',
    exchangeRateAlternateDate:
      'Exchange rate from {{requestedDate}} for {{currency}} not found, using rate from {{foundDate}}',
    exchangeRateAlternateMultipleDate:
      'Exchange rates from {requestedDate} not found, using rates from {foundDate}',
    buyer: 'Buyer',
    seller: 'Seller',
    ordinalNumber: '#',
    activity: 'Activity',
    quantity: 'Quantity',
    logNumber: 'Log number',
    code: 'Invoice number',
    exchangeRate: 'Exchange rate',
    price: 'Unit price',
    unit: 'Unit',
    netValue: 'Net value',
    taxRate: 'VAT',
    taxValue: 'VAT value',
    grossValue: 'Gross value',
    total: 'Total',
    totalDifference: 'Total difference',
    including: 'Including',
    addCorrective: 'Add corrective',
    addAllocation: 'Add allocation',
    allocation: 'Allocation',
    updateAllocation: 'Update allocation',
    allocationInfo: 'Allocation information',
    allocations: 'Allocations',
    allocationAmount: 'Allocation amount',
    allocationSum: 'Total allocation sum',
    allocationState: 'Allocation state',
    allocationActivity: 'Activity',
    allocationSummaryCount: 'Including:',
    allocationSummaryAmount: 'Amount',
    allocationNoService: 'Other',
    invoiceType: 'Invoice type',
    complaintReason: 'Complaint reason',
    rejectionReason: 'Rejection reason',
    rejectionAcknowledgment: "I've acknowledged rejection reason",
    rejectionAcknowledmentSuccess: 'Rejection reason acknowledged',
    addOwn: 'Add own',
    addForeign: 'Add foreign',
    exportToFile: 'Export',
    markAsPaid: 'Settle',
    allocatedAmount: 'Allocated amount',
    unallocatedAmount: 'Unallocated amount',
    invoiceAmount: 'Invoice amount',
    exportDate: 'Export date',
    publishSuccess: 'Invoice is now published',
    unpublishSuccess: 'Invoice is now unpublished',
    paidSuccess: 'Invoice status changed to "Paid"',
    unpaidSuccess: 'Invoice status changed to "Not paid"',
    createInvoiceWarning: 'Chosen invoice type is currently not supported',
    clearCorrectionRequired: 'Reject complaint',
    clearedRequiresCorrectionMark: 'Invoice complaint is now rejected.',
    unpublish: 'Revert publishing',
    stateFrom: 'State from',
    issuer: 'Issuer',
    np: 'NP',
    publicationDate: 'Publication date',
    originalExternalName: 'Original service name',
    selectKeywords: 'Identify the keywords in the original service name',
    invoiceTypeLabels: {
      OWN: 'Own',
      FOREIGN: 'Foreign',
    },
    classTypes: {
      VAT: 'Vat',
      VAT_CORRECTIVE: 'Vat Corrective',
      ACCOUNT_NOTE: 'Account Note',
      CORRECTION_NOTE: 'Correction Note',
      NO_VAT: 'No Vat',
      NO_VAT_CORRECTIVE: 'No Vat Corrective',
      ADMINISTRATIVE: 'Administrative',
      ADMINISTRATIVE_CORRECTIVE: 'Administrative corrective',
    },
    allocationStatusLabel: 'Allocation status',
    allocationProgress: {
      ALL: 'All',
      INITIAL: 'In progress',
      PARTIAL: 'Partially allocated',
      FULL: 'Completely allocated',
      ACCEPTED: 'Allocations accepted',
      FINALIZED: 'Exported',
      CANCELLED: 'Cancelled',
      COMPLAINED: 'Has complaint',
    },
    allocationStatus: {
      PENDING: 'Unaccepted',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      REQUIRES_CORRECTION: 'Complained',
    },
    goToInvoice: 'Go to invoice',
    goToJob: 'Go to job',
    seeInSaldeo: 'See in Saldeo',
    accept: 'Accept allocation',
    invoiceStatus: {
      PAID: 'Paid',
      NOT_PAID: 'To be paid',
    },
    invoicePublished: {
      label: 'All',
      EXPORTED: 'Exported',
      READY: 'Published',
      DRAFT: 'Not published',
    },
    notPaid: 'Not paid',
    paid: 'Paid',
    unknownInvoiceMsg:
      'Requires the assignment of item to the discriminant by the manager',
    allocationFailedMsg: 'Requires manual allocation',
    chooseLang: 'Choose a language',
    cancelInvoiceHeading: 'Confirm cancellation',
    cancelInvoiceBody:
      'Are you sure you want to delete this invoice. This operation cannot be undone.',
    cancelInvoiceButton: 'Cancel invoice',
    markAllocationForCorrection: 'Complain',
    allocationMarkedForCorrection: 'Complaint placed',
    unpublished: 'Unpublished',
    withdraw: 'Withdraw the complaint',
    correctionWithdrawn: 'Complaint withdrawn',
    circulationLicenceDate: 'Circulation licence date',
    vehicleMileage: 'Vehicle mileage in km',
    vehicleHours: 'Vehicle work hours',
    complaint: 'Complaint',
    createInvoice: 'Create invoice',
    fetchPartial:
      'Fetched {{totalSaved}} of {{totalFound}} invoices. Check the notification panel above the table for details.',
    fetchSuccess_one: 'Successfully fetched {{count}} invoice.',
    fetchSuccess_other: 'Successfully fetched {{count}} invoices.',
    noInvoicesFound: 'No new invoices to fetch from {{systemFrom}}.',
    fetchAlreadyRunning:
      'Fetching invoices from {{systemFrom}} is already in progress. Please try again later.',
    fetchTimeout:
      'Fetching invoices from {{systemFrom}} is taking longer than expected. Please check back in a moment - results should appear in the table soon.',
    fetchError:
      'Communication error with {{systemWith}} occurred. Please try again later.',
    enovaFetchSuccess:
      'Imported confirmations from {{processedFiles}} files ({{matched}} items).',
    enovaFetchPartial:
      'Imported {{matched}} of {{totalRows}} items. Check problematic records / contact administration.',
    enovaNoNewFiles: 'No new files found for import.',
    enovaFetchError:
      'Import is already running or an error occurred. Please try again / contact administration.',
  },
  rates: {
    deleteRateSuccess: 'Rate deleted',
    deleteRateFailure: 'Error occurred while deleting rate',
    editSuccess: 'Rate edited',
    depublishSuccess: 'Rate depublished',
    depublishFailure: 'Failed to depublish rate',
    publicationSuccess: 'Rate published',
    publicationFailure: 'Failed to publish rate',
    depublish: 'Depublish',
    published: 'Published',
    draft: 'Draft',
    status: 'Status',
    save: 'Save',
    publish: 'Publish',
    duplicate: 'Duplicate',
    rate: 'Rate',
    data: 'Data',
    unit: 'Unit',
    cost: 'Cost',
    currency: 'Currency',
    publicationDateFrom: 'Publication date from',
    publicationDateTo: 'Publication date to',
    all: 'All',
    onlyMine: 'Only mine',
    relation: 'Relation',
    routeTooManyValidation: 'Too many values inserted',
    seaFreight: 'Sea freight',
    rowsPerPageLabel: 'Rows per page',
    rateNumber: 'Rate number',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    region: 'Region',
    activities: 'Activities',
    publicationDate: 'Publication date',
    addRate: 'Add rate',
    contractNumber: 'Contract number',
    tradeType: 'Relation',
    shipowner: 'Shipowner',
    commodity: 'Commodity',
    namedAccount: 'NamedAccount',
    routeFrom: 'Route from',
    routeTo: 'Route to',
    containerType: 'Container',
    activity: 'Activity',
    rateAllIn: 'Rate all-in',
    expirationDateFrom: 'Expiration date from',
    expirationDateTo: 'Expiration date to',
    daysOff: 'Days off',
    internalNote: 'Internal note',
    addNewActivity: 'Add new activity',
    removeActivity: 'Remove',
    deleteRateHeading: 'Confirm rate removal',
    deleteRateBody:
      'Are you sure you want to remove this rate? This operation cannot be undone.',
    null: 'None',
    namedAccountValidationRules: 'The None option must occur individually',
  },
  transportCloud: {
    table: {
      headers: {
        lp: 'Parameter',
        shippingLine: 'Shipowner',
        containerType: 'Type',
        customer: 'Client',
        job: 'Job',
        referenceNumbers: 'Reference number',
        bookingNumber: 'Booking',
        pinCode: 'Pin',
        tradeType: 'Relation',
        pickupLocation: 'Pickup Location',
        pickupDate: 'Pickup Date',
        loadingDeliveryLocation: 'Loading / Delivery',
        loadingDeliveryDate: 'Loading / Delivery Date',
        deliveryLocation: 'Drop Off Place',
        deliveryDate: 'Drop Off Date',
        customsClearance: 'Clearance',
        weighing: 'Weighing',
        productGroup: 'Cargo',
        loadDescription: 'Cargo Description',
        comment: 'Comments',
        documents: 'Documents',
        offerTruckerRate: 'Offer Rate',
        truckerRate: 'Trucker Rate',
        containerNumber: 'Container Number',
        triangulation: 'Triangulation',
        containerStatus: 'Container Status',
        trucker: 'Trucker',
        driverName: 'Driver',
        driverDocumentNumber: 'ID Card',
        driverPhone: 'Phone',
        vehicleRegistrationNumber: 'Tractor',
        trailerRegistrationNumber: 'Trailer',
        reportNotes: 'Reports',
        actions: 'Actions',
        shippingLineHaulage: 'Shipping line transport',
      },
      dayNames: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        noLoadingDeliveryDate: 'Without loading/delivery date',
      },
      statuses: {
        customsClearance: {
          none: 'None',
          import: {
            inProgress: 'In transit',
            done: 'Cleared',
          },
          export: {
            inProgress: 'At port',
            done: 'At warehouse',
          },
        },
        triangulation: {
          inApproval: 'In approval',
          approved: 'Approved ✅',
          none: 'None',
          depot: 'From the depot',
        },
        weighing: {
          atLoading: 'At loading',
          atPort: 'At the port',
          otherAddress: 'Other address',
        },
      },
      validations: {
        containerNumber: 'The value must comply with the ISO6346 standard.',
        containerType: 'Container type is required.',
        loadingDeliveryDate:
          'Delivery date must be later than pickup date and earlier than drop off date.',
        pickupDate:
          'Pickup date must be earlier than delivery date and drop off date.',
        deliveryDate:
          'Drop off date must be later than pickup date and delivery date.',
        shippingLine: 'Shipowner is required.',
        truckerRateValue: 'Currency is required when rate is filled in.',
        truckerRateCurrency: 'Rate is required when currency is selected.',
        truckerRateNegative: 'Rate cannot be negative.',
        referenceNumbers:
          'Each reference number must contain between 2 and 64 characters.',
        comment: 'Comment cannot exceed 256 characters.',
        bookingNumber: 'Booking cannot exceed 64 characters.',
        driverName: 'Driver name cannot exceed 40 characters.',
        driverDocumentNumber:
          'Driver document number cannot exceed 40 characters.',
        driverPhone: 'Phone number cannot exceed 20 characters.',
        vehicleRegistrationNumber:
          'Vehicle registration number cannot exceed 40 characters.',
        trailerRegistrationNumber:
          'Trailer registration number cannot exceed 40 characters.',
        reportNotes: 'Report notes cannot exceed 256 characters.',
        loadDescription: 'Load description cannot exceed 256 characters.',
        pinCode: 'Pin code must contain between 2 and 64 characters.',
      },
      required: {
        loadingDeliveryDate: 'Delivery date is required.',
        pickupDate: 'Pickup date is required for entries of type IMPORT.',
        deliveryDate: 'Drop off date is required for entries of type EXPORT.',
        loadingDeliveryLocation: 'Loading/delivery location is required.',
        pickupLocation:
          'Pickup location is required for entries of type IMPORT.',
        deliveryLocation:
          'Delivery location is required for entries of type EXPORT.',
      },
      filters: {
        dateFrom: 'Delivery date from',
        dateTo: 'Delivery date to',
        onlyMine: 'Only mine',
      },
      buttons: {
        addEntry: 'Add transport entry',
        viewSettings: 'VIEW SETTINGS',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        yes: 'Yes',
        no: 'No',
        reload: 'Reload',
        accept: 'Accept',
        send: 'Send',
      },
      errors: {
        systemError: 'An unexpected server error occurred. Please try again.',
        capturedError:
          'This field could not be edited because the load is captured.',
        capturedEditDisabled:
          'This field cannot be edited because the load is captured.',
        elseModifiedError:
          'Someone else modified this record at the same time. Please try again.',
        deleteError: 'Failed to delete records. Please try again.',
        deleteErrorDataIntegrityViolation:
          'The selected records cannot be deleted because at least one of them has active links in the system.',
        importEditDisabled:
          'This field cannot be edited for import relation loads.',
        exportEditDisabled:
          'This field cannot be edited for export relation loads.',
        noPrivilegeEditDisabled: "You don't have privileges to edit this cell.",
        noPrivilegeDeleteDisabled:
          "You are trying to delete records which you don't have privileges to delete.",
        noPrivilegeAddLoadDisabled:
          "You don't have privileges to add a load to this job.",
        containerNumberError:
          'Container with this number is already present in job.',
        mailSenderNoPermission: 'You do not have permission to send emails.',
        mailSenderNoSelection: 'Select at least one row.',
        mailSenderNotAllJobRows: 'Only job rows can be selected for sending.',
        mailSenderNotSameJob: 'All selected rows must belong to the same job.',
        mailSenderNoTrucker: 'All selected rows must have a trucker assigned.',
        mailSenderNotOwner: 'You can only send emails for your own records.',
        driverAddError:
          'Failed to add driver to the database. Please try again.',
        driverUpdateError:
          'Failed to update driver in the database. Please try again.',
        driverDeleteErrorSingle:
          'Failed to delete driver from the database. Please try again.',
        driverDeleteErrorMultiple:
          'Failed to delete drivers from the database. Please try again.',
      },
      overlays: {
        dateChangeOverlay:
          'A change of the delivery date to {{date}} has been proposed for this record. Press Accept to confirm the change.',
        dateChangeAcceptedOverlay:
          'The delivery date change to {{date}} for this record has already been accepted. Refresh the page to see the current view.',
        deleteOverlay: 'The record has been deleted.',
      },
      dialogs: {
        multiEditingConfirmation:
          'Do you want to edit field for all checked records?',
        acceptMultiEditingConfirmation:
          'Do you want to accept this delivery date change for all checked records?',
        multiEditingCheck: 'Uncheck records after saving.',
        confirmDelete:
          'Are you sure you want to delete the selected records? This operation cannot be undone.',
        viewSettingsHeader: 'View settings',
        mailSenderHeader: 'New message - {{title}}',
        notificationLabel: 'Notification',
        notificationSuccessMessage: 'Notification sent successfully.',
        waybillLabel: 'Waybill',
        waybillSuccessMessage: 'Waybill sent successfully.',
        toLabel: 'To',
        ccLabel: 'CC',
        bccLabel: 'BCC',
        subjectLabel: 'Subject',
        headingOneButton: 'Heading 1',
        headingTwoButton: 'Heading 2',
        headingThreeButton: 'Heading 3',
        boldButton: 'Bold',
        italicButton: 'Italic',
        strikethroughButton: 'Strikethrough',
        orderedListButton: 'Ordered list',
        bulletListButton: 'Bullet list',
        addRowBeforeButton: 'Add row before',
        addRowAfterButton: 'Add row after',
        deleteRowButton: 'Delete row',
        addColumnBeforeButton: 'Add column before',
        addColumnAfterButton: 'Add column after',
        deleteColumnButton: 'Delete column',
        mergeCellsButton: 'Merge cells',
        splitCellsButton: 'Split cells',
        cellBackgroundButton: 'Cell background',
        deleteTableButton: 'Delete table',
        notificationDisabledTooltip:
          'Waybill must be sent before sending a notification',
        waybillDisabledTooltip:
          'Each selected row must have a container number or pickup location filled in.',
        cloudManagement: 'Cloud management',
        cloudManagementStatuses: 'Container statuses',
        cloudManagementDriversDatabase: 'Drivers database',
        driverAddSuccessMessage: 'Driver has been added to the database.',
        driverAddErrorMessage:
          'Driver with given document id already exists in the database.',
        driverUpdateSuccessMessage: 'Driver has been updated in the database.',
        driverDeleteSuccessMessageSingle:
          'Driver has been deleted from the database.',
        driverDeleteSuccessMessageMultiple:
          'Drivers have been deleted from the database.',
        driverAddConfirm: 'Do you want to add a new driver to the database?',
        driverEditConfirm:
          "Do you want to change the driver's data in the database?",
        hexLabel: 'Hex',
        noColorTooltip: 'No color',
        statusAddSuccessMessage: 'The status has been added.',
        statusUpdateSuccessMessage: 'The status has been updated.',
        statusDeleteSuccessMessageSingle: 'The status has been deleted.',
        statusDeleteSuccessMessageMultiple: 'The statuses have been deleted.',
      },
    },
    form: {
      title: 'Add transport entry',
      labels: {
        date: 'Date',
        amount: 'Amount',
        customer: 'Customer',
        relation: 'Relation',
        loadingDeliveryLocation: 'Loading/Delivery Location',
        truckersRate: 'Truckers Rate',
        containerNumbers: 'Container Numbers',
        comment: 'Comments',
        trucker: 'Trucker',
        currency: 'Currency',
        shipowner: 'Shipowner',
        containerSize: 'Container Size',
      },
      buttons: {
        addEntry: 'Add entry',
        save: 'Save',
        cancel: 'Cancel',
      },
      validation: {
        truckersRate: 'This field is required when currency is provided.',
        currency: 'This field is required when truckers rate is provided.',
        amount: 'Amount must be greater than 0.',
        containerNumbersISO:
          'The values must comply with the ISO6346 standard.',
        containerNumbersAmount:
          'The number of container numbers cannot exceed a specified amount.',
      },
    },
  },
  mapping: {
    internalActivity: 'Internal activity',
    counterparty: 'Counterparty',
    externalActivity: 'External activity',
    addInternalActivity: 'Add internal activity',
    addExternalActivity: 'Add external activity',
    deleteExternalActivitySuccess: 'The external service has been deleted.',
    deleteExternalActivityError:
      'An error occurred while deleting the external service. Please try again.',
    deleteExternalActivity: 'Delete external activity',
    confirmDeleteExternalActivity:
      'Are you sure you want to delete the selected external services?',
    all: 'All',
    search: 'Search',
    addExternalActivityError:
      'An error occurred while adding the external service. Please try again.',
    addExternalActivitySuccess: 'The external service has been added.',
    updateExternalActivityError:
      'An error occurred while updating the external service. Please try again.',
    updateExternalActivitySuccess: 'The external service has been updated.',
    collapse: 'collapse',
    servicesPlural1: 'service',
    servicesPlural2: 'services',
    servicesPlural3: 'services',
    counterpartiesPlural1: 'counterparty',
    counterpartiesPlural2: 'counterparties',
    counterpartiesPlural3: 'counterparties',
    notSpecified: 'Not specified',
    patternEditDisabled:
      "Editing mapping patterns isn't available at this moment",
  },
  exchangeRate: {
    fromCurrency: 'Base currency',
    toCurrency: 'Destination currency',
    rate: 'Rate',
    multiplier: 'Multiplier',
    type: 'Type',
    date: 'Date',
    source: 'Source',
    registry: {
      registry: 'Registry',
      filename: 'Filename',
      description: 'Description',
      date: 'Date',
    },
    labels: {
      BID: 'Buying rate',
      ASK: 'Selling rate',
      AVERAGE: 'Average rate',
    },
    fromRate: 'From rate',
    toRate: 'To rate',
  },
  door: {
    city: 'Door city',
    countryCode: 'Door country',
  },
  mail: {
    from: 'From',
    to: 'To',
    cc: 'CC',
    bcc: 'BCC',
    subject: 'Subject',
    send: 'Send',
    header: 'New message',
    job: 'Job',
    offer: 'Offer',
    successMessage: 'Message has been sent successfully.',
  },
  itemConfiguration: {
    itemType: 'Item type',
    tradeType: 'Relation',
    loadType: 'Category',
    tradeTypeLabels: {
      IMPORT: 'Import',
      EXPORT: 'Export',
      COUNTRY: 'Country',
    },
    loadTypeLabels: {
      FCL: 'FCL',
      LCL: 'LCL',
      FTL: 'FTL',
      LTL: 'LTL',
    },
    validationMessages: {
      anyField: 'At least one of these fields needs a value',
    },
    activity: 'Activity',
    unit: 'Unit',
    businessFunction: 'Counterparty',
    currency: 'Currency',
  },
  counterpartyImport: {
    import: 'Data import from GUS',
    captcha: 'Captcha code',
    number: 'NIP number',
    mode: 'Mode',
    modes: {
      nip: 'NIP',
      regon: 'Regon',
    },
    getCaptcha: 'Reload captcha',
    importData: 'Import',
    loading: 'Loading',
    failed: 'Failed',
  },
  address: {
    lineOne: 'Address',
    lineTwo: 'Post code',
    city: 'City',
    countryCode: 'Country',
    addressDetails: 'Address details',
  },
  transportWaypoint: {
    address: 'Address',
    date: 'Date',
    referenceNumber: 'Reference number',
  },
  entryRoute: {
    labels: {
      import: {
        start: 'Terminal',
        node: 'Unload',
        end: 'Empty discharge',
      },
      export: {
        start: 'Empty pickup',
        node: 'Load',
        end: 'Terminal',
      },
      country: {
        node: 'Stop',
      },
      nodeTL: {
        start: 'Load',
        end: 'Unload',
      },
    },
    addManually: 'Add manually',
    addStorehouse: 'Save storehouse',
  },
  reports: {
    invoice: {
      label: 'Invoices report',
      invoiceCode: 'Invoice number',
      jobCode: 'Job number',
      issueDate: 'Issue date',
      saleDate: 'Sale date',
      amount: 'Amount',
      dueDate: 'Due date',
      dueDays: 'Due days:',
      counterparty: 'Counterparty',
      unpaidTotal: 'Not paid invoices amount',
      averageOverdue: 'Average overdue days',
      overdueDays: 'Overdue days',
      averageDelay: 'Average delay',
      including: 'Including:',
      status: {
        label: 'Status',
        PAID: 'Paid',
        NOT_PAID: 'Not paid',
      },
      published: {
        label: 'All',
        PUBLISHED: 'Published',
        UNPUBLISHED: 'Unpublished',
      },
      ksefNumber: 'KSeF',
    },
    job: {
      label: 'Jobs report',
      forwarder: 'Forwarder',
      startExecutionDate: 'Start execution date',
      endExecutionDate: 'End execution date',
      country: 'Country',
      city: 'City',
      jobs: 'Jobs',
      containers: 'Containers',
      total: 'Total:',
      tradeKeeper: 'Trade keeper',
    },
    activity: {
      label: 'Activities report',
      labelCP: 'Activity report',
      customer: 'Customer',
      user: 'User',
      requests: 'Requests',
      offers: 'Offers',
      orders: 'Orders',
      jobs: 'Jobs',
      jobEntries: 'Job entries',
      invoices: 'Invoices',
      type: {
        USER: 'User',
        CUSTOMER: 'Customer',
      },
    },
    container: {
      label: 'Containers report',
      type: {
        RELATION: 'Relation',
        USER: 'User',
      },
      port: 'Port',
      region: 'Region',
      forwarder: 'Forwarder',
      customer: 'Customer',
      shippingLine: 'Shipping line',
    },
    oceanSchedules: {
      label: 'Ocean Schedules',
      originPort: 'Origin port',
      destinationPort: 'Destination port',
      searchDate: 'Search date',
      searchDateType: 'Search date type: ',
      directOnly: 'Direct only',
      includeNearbyOriginPorts: 'Include nearby origin ports',
      includeNearbyDestinationPorts: 'Include nearby destination ports',
      departureDate: 'Departure date',
      arrivalDate: 'Arrival date',
      weeksOut: 'Weeks out',
      scacs: 'Shipping lines',
      shippingLine: 'Shipping line',
      cutOff: 'Cut-Off',

      generalInformation: 'General information',
      scac: 'Carriers SCAC',
      carrierName: 'Carrier name',
      terminalCutoff: 'Terminal cutoff',
      estimatedTerminalCutoff: 'Estimated terminal cutoff',
      bkCutoff: 'Booking cutoff',
      siCutoff: 'Shipping instruction cutoff',
      hazBkCutoff: 'Hazardous booking cutoff',
      vgmCutoff: 'VGM cutoff',
      reeferCutoff: 'Reefer cutoff',
      serviceName: 'Service name',
      vesselName: 'Vessel name',
      voyageNumber: 'Voyage number',
      imoNumber: 'IMO number',
      originUnloc: 'Origin terminal UNECE',
      originCityName: 'Origin port',
      originSubdivision: 'Origin subdivision',
      originCountry: 'Origin country',
      originTerminal: 'Origin terminal',
      originDepartureDate: 'ETD',
      destinationUnloc: 'Destination terminal UNECE',
      destinationCityName: 'Destination port',
      destinationSubdivision: 'Destination subdivision',
      destinationCountry: 'Destination country',
      destinationTerminal: 'Destination terminal',
      destinationArrivalDate: 'ETA',
      totalDuration: 'TT',
      scheduleType: 'Schedule type',
      legs: 'List of terminals',

      legsDetails: {
        sequence: 'Sequence number',
        serviceName: 'Service name',
        transportType: 'Transport type',
        transportName: 'Transport name',
        conveyanceNumber: 'Conveyance number',
        transportID: 'IMO number',
        departureUnloc: 'Departure terminal UNECE',
        departureCityName: 'Departure city',
        departureSubdivision: 'Departure subdivision',
        departureCountry: 'Departure country',
        departureTerminal: 'Departure terminal',
        departureDate: 'Departure date',
        arrivalUnloc: 'Arrival terminal UNECE',
        arrivalCityName: 'Arrival city',
        arrivalSubdivision: 'Arrival subdivision',
        arrivalCountry: 'Arrival country',
        arrivalTerminal: 'Arrival termianl',
        arrivalDate: 'Arrival date',
        transitDuration: 'Transit duration in days',
        transshipmentIndicator: 'Is transshipment',
      },
    },
    offer: {
      label: 'Offers report',
      loadingPort: 'Port of loading',
      unloadingPort: 'Port of unloading',
      containerSize: 'Size',
      containerType: 'Type',
      route: 'Route',
    },
    import: 'Import',
    export: 'Export',
  },
  serviceTypes: {
    serviceTypeLabels: {
      ADMINISTRATIVE: 'Administrative',
      ALL_IN: 'All-in',
      AGENT: 'Agent',
      CUSTOMS: 'Customs',
      DEPOT: 'Depot',
      FREIGHT: 'Freight',
      FREIGHT_MAINTENANCE: 'Freight maintenance',
      INSURANCE: 'Insurance',
      OTHER: 'Other',
      TERMINAL: 'Terminal',
      TRANSPORT: 'Land transport',
    },
  },
  login: {
    info: 'Please sign in.',
    signin: 'Sign in',
    notsuccessful: 'Your login attempt was not successful, try again.',
    logout: 'Logout successful.',
    expired: 'Your login session has expired.\nPlease sign in again.',
    userPlaceholder: 'User',
    passwordPlaceholder: 'Password',
    accountExpired: 'Account expired.',
    passwordExpired: 'Password expired, enter new one.',
    locked: 'Account is locked.',
    disabled: 'Account is disabled.',
    passwordChanged: 'Password changed.\nPlease sign in again.',
    newPasswordPlaceholder: 'New password',
    newPasswordConfirmationPlaceholder: 'Repeat new password',
    passwordsNotEqual: 'Passwords are not the same',
    fieldRequired: 'Field is required',
    acceptances: 'Acceptances',
  },
  Containers: {
    isoCode: 'ISO Code',
  },
  requestForOffer: {
    create: 'New request',
    code: 'Request number',
    send: 'Send',
    print: 'Print',
    requestRecipient: 'Request recipient',
    sendingDate: 'Date of sending',
    description: 'Notes',
    productName: 'Product name',
    deliveryType: 'Delivery type',
    containerSorts: 'Container sorts',
    totalCargoWeight: 'Total cargo weight',
    totalCargoCapacity: 'Total cargo capacity',
    loadType: 'Load type',
    relations: 'Relations',
    addRelation: 'Add relation',
    loadingPoint: 'Loading point',
    deliveryPoint: 'Delivery point',
    sendConfirmation: 'Are you sure you want to send this request for offer?',
    requestSent: 'Request sent',
    archive: 'Archive',
    receivingDate: 'Date of receiving',
    status: 'Status',
    customer: 'Customer',
    addOffer: 'Add offer',
    archiveConfirmation:
      'Are you sure you want to archive this request for offer?',
    onlyCurrent: 'Only current',
    loadTypes: {
      FULL_LOAD: 'Full load',
      PARTIAL_LOAD: 'Partial load',
    },
    deliveryTypes: {
      CONTAINER: 'Container',
      TARPAULIN: 'Tarpaulin',
      SMALL_LOAD: 'Small load',
    },
    statuses: {
      CURRENT: 'Current',
      ARCHIVED: 'Archived',
    },
  },
  regions: {
    countries: 'Countries',
  },
  forecasts: {
    startingRegion: 'Starting region',
    targetRegion: 'Target region',
    forecast: 'Forecast',
    diagram: 'Preview',
    date: 'Date',
    pmi: 'PMI',
    baf: 'BAF',
    tonnage: 'Tonnage',
    addPoint: 'Add point',
    generatePreview: 'Generate preview',
    chartTitle: 'Freight price forecast',
    relation: 'Relation',
    currentPrice: 'Current price',
    calculateForecast: 'Calculate forecast',
    warningLabelHeader: 'Note!',
    warningLabelText:
      'Due to unstable political situation is not possible to forecast prices of freight to Africa, Middle East and Persian Gulf',
    chartDateFormat: 'MM/dd/yyyy',
  },
  jpk: {
    fullName: 'Full name',
    nip: 'NIP',
    regon: 'REGON',
    taxOfficeCode: 'Tax office code',
    voivodeship: 'Voivodeship',
    district: 'District',
    commune: 'Commune',
    city: 'City',
    countryCode: 'Country code',
    street: 'Street',
    houseNumber: 'House number',
    apartmentNumber: 'Apartment number',
    post: 'Post',
    postalCode: 'Postal Code',
    primaryCounterpartyDataNotFilled:
      'You have to fill main counterparty data to generate JPK file.',
  },
  privileges: {
    sectionName: 'Privileges',
    REQUESTS: {
      name: 'Requests',
      MODULE_REQUESTS_VIEW_LIST: 'Viewing the list of requests',
      MODULE_REQUESTS_VIEW_DETAILS: 'Viewing request details',
      MODULE_REQUESTS_ARCHIVE: 'Archiving requests',
      MODULE_REQUESTS_PRINT: 'Printing request',
    },
    NOTIFICATIONS: {
      name: 'Notifications',
      MODULE_NOTIFICATIONS_CONTAINERS:
        'Displaying notifications about containers',
      MODULE_NOTIFICATIONS_INVOICES: 'Displaying notifications about invoices',
      MODULE_NOTIFICATIONS_CARRIERS: 'Displaying notifications about carries',
    },
    OFFERS: {
      name: 'Offers',
      MODULE_OFFERS_VIEW_OFFER_LIST: 'Viewing the list of offers',
      MODULE_OFFERS_VIEW_OFFER_DETAILS: 'Viewing offer details',
      MODULE_OFFERS_CREATE_OFFER: 'Creating an offer',
      MODULE_OFFERS_EDIT_OFFER: 'Editing offers',
      MODULE_OFFERS_EDIT_OFFER_OWNER: 'Editing offers (owner)',
      MODULE_OFFERS_DELETE_OFFER: 'Deleting offers',
      MODULE_OFFERS_DELETE_OFFER_OWNER: 'Deleting offers (owner)',
      MODULE_OFFERS_ADD_OFFER_ITEM: 'Adding item to offer',
      MODULE_OFFERS_ADD_OFFER_ITEM_OWNER: 'Adding item to offer (owner)',
      MODULE_OFFERS_VIEW_ITEM_DETAILS: "Viewing item's details",
      MODULE_OFFERS_EDIT_ITEM_DETAILS: "Editing item's details",
      MODULE_OFFERS_EDIT_ITEM_DETAILS_OWNER: "Editing item's details (owner)",
      MODULE_OFFERS_COPY_ITEM: 'Copying item',
      MODULE_OFFERS_COPY_ITEM_OWNER: 'Copying item (owner)',
      MODULE_OFFERS_COPY_OFFER: 'Copying offer',
      MODULE_OFFERS_COPY_OFFER_OWNER: 'Copying offer (owner)',
      MODULE_OFFERS_PUBLISH_OFFER: 'Publishing an offer',
      MODULE_OFFERS_PUBLISH_OFFER_OWNER: 'Publishing an offer (owner)',
      MODULE_OFFERS_ADD_ANEX_TO_OFFER: 'Ading an annex to a published offer',
      MODULE_OFFERS_ADD_ANEX_TO_OFFER_WHICH_RESULTED_IN_JOB:
        'Adding an annex to a published offer when earlier offer was used by him to make job based on it',
      MODULE_OFFERS_PRINT_OFFER: 'Printing an offer',
      MODULE_OFFERS_MAIL_OFFER: 'Mailing an offer',
      MODULE_OFFERS_MAIL_OFFER_OWNER: 'Mailing an offer (owner)',
      MODULE_OFFERS_CREATE_JOB_FROM_OFFER: 'Creating a job from offer',
    },
    ORDERS: {
      name: 'Orders',
      MODULE_ORDERS_VIEW_ORDER_LIST: 'Viewing the list of orders',
      MODULE_ORDERS_VIEW_ORDER_DETAILS: "Viewing order's details",
      MODULE_ORDERS_PRINT_ORDER: 'Printing order',
      MODULE_ORDERS_CHANGE_ORDER_STATUS: 'Changing order status',
      MODULE_ORDERS_CREATE_JOB_FROM_ORDER: 'Creating job from order',
    },
    JOBS: {
      name: 'Jobs',
      MODULE_JOBS_VIEW_JOB_LIST: 'Viewing the list of jobs',
      MODULE_JOBS_VIEW_JOB_DETAILS: "Viewing job's details",
      MODULE_JOBS_EDIT_JOB: 'Editing a job',
      MODULE_JOBS_EDIT_JOB_OWNER: 'Editing a job (owner)',
      MODULE_JOBS_DELETE_JOB: 'Deleting a job',
      MODULE_JOBS_DELETE_JOB_OWNER: 'Deleting a job (owner)',
      MODULE_JOBS_ADD_EVENT: 'Adding an event',
      MODULE_JOBS_ADD_EVENT_OWNER: 'Adding an event (owner)',
      MODULE_JOBS_DELETE_EVENT: 'Deleting an event',
      MODULE_JOBS_DELETE_EVENT_OWNER: 'Deleting an event (owner)',
      MODULE_JOBS_ADD_LOAD: 'Adding a load',
      MODULE_JOBS_ADD_LOAD_OWNER: 'Adding a load (owner)',
      MODULE_JOBS_COPY_LOAD: 'Copying a load',
      MODULE_JOBS_COPY_LOAD_OWNER: 'Copying a load (owner)',
      MODULE_JOBS_DELETE_LOAD: 'Deleting a load',
      MODULE_JOBS_DELETE_LOAD_OWNER: 'Deleting a load (owner)',
      MODULE_JOBS_ADD_SERVICE: 'Adding a service',
      MODULE_JOBS_ADD_SERVICE_OWNER: 'Adding a service (owner)',
      MODULE_JOBS_COPY_SERVICE: 'Copying a service',
      MODULE_JOBS_COPY_SERVICE_OWNER: 'Copying a service (owner)',
      MODULE_JOBS_DELETE_SERVICE: 'Deleting a service',
      MODULE_JOBS_DELETE_SERVICE_OWNER: 'Deleting a service (owner)',
      MODULE_JOBS_GENERATE_DOWNLOAD_DOCUMENTS:
        'Generating/downloading documents',
      MODULE_JOBS_MAIL_DOCUMENTS: 'Mailing documents',
      MODULE_JOBS_MAIL_DOCUMENTS_OWNER: 'Mailing documents (owner)',
      MODULE_JOBS_SEND_EDI_MESSAGE: 'Sending an edi message',
      MODULE_JOBS_SEND_EDI_VGM_MESSAGE: 'Sending an edi VGM message',
      MODULE_JOBS_CREATE_INVOICE_FROM_JOB: 'Creating an invoice from job',
      MODULE_JOBS_ADD_STOREHOUSE: 'Adding storehouse',
      MODULE_JOBS_VIEW_TRACK_AND_TRACE: 'Viewing Track and Trace details',
      MODULE_JOBS_SEND_CONTAINER_NOTIFICATION: 'Send container notification',
      MODULE_JOBS_RELEASE_DETENTION_STATUS:
        'Release container under detention status',
    },
    INVOICES: {
      name: 'Invoices',
      MODULE_INVOICES_VIEW_INVOICE_LIST: 'Viewing the list of invoices',
      MODULE_INVOICES_VIEW_INVOICE_DETAILS: "Viewing an invoice's details",
      MODULE_INVOICES_CREATE_OWN_INVOICE: 'Creating an own invoice',
      MODULE_INVOICES_CREATE_ADMIN_INVOICE: 'Creating an own invoice',
      MODULE_INVOICES_ADD_FOREIGN_INVOICE: 'Adding a foreign invoice',
      MODULE_INVOICES_DELETE_OWN_INVOICE_OWNER:
        'Deleting an own invoice (owner)',
      MODULE_INVOICES_DELETE_OWN_INVOICE_UNPUBLISHED:
        'Deleting an own invoice (unpublished)',
      MODULE_INVOICES_DELETE_FOREIGN_INVOICE_UNPUBLISHED:
        'Deleting a foreign invoice (unpublished)',
      MODULE_INVOICES_DELETE_ADMIN_INVOICE_OWNER:
        'Deleting an administrative invoice (owner)',
      MODULE_INVOICES_DELETE_ADMIN_INVOICE_UNPUBLISHED:
        'Deleting an administrative invoice (unpublished)',
      MODULE_INVOICES_PRINT_INVOICE: 'Printing an invoice',
      MODULE_INVOICES_PUBLISH_OWN_INVOICE: 'Publishing an own invoice',
      MODULE_INVOICES_PUBLISH_OWN_INVOICE_OWNER:
        'Publishing an own invoice (owner)',
      MODULE_INVOICES_PUBLISH_FOREIGN_INVOICE: 'Publishing a foreign invoice',
      MODULE_INVOICES_PUBLISH_ADMIN_INVOICE:
        'Publishing an administrative invoice',
      MODULE_INVOICES_PUBLISH_ADMIN_INVOICE_OWNER:
        'Publishing an administrative invoice (owner)',
      MODULE_INVOICES_EDIT_OWN_INVOICE: 'Editing own invoice',
      MODULE_INVOICES_EDIT_OWN_INVOICE_OWNER: 'Editing own invoice (owner)',
      MODULE_INVOICES_EDIT_FOREIGN_INVOICE: 'Editing foreign invoice',
      MODULE_INVOICES_EDIT_ADMIN_INVOICE: 'Editing administrative invoice',
      MODULE_INVOICES_EDIT_ADMIN_INVOICE_OWNER:
        'Editing administrative invoice (owner)',
      MODULE_INVOICES_ADD_ALLOCATION: 'Adding allocations',
      MODULE_INVOICES_DELETE_ALLOCATION: 'Deleting allocations',
      MODULE_INVOICES_REVIEW_ALLOCATION:
        'Accepting/complaining/rejecting allocations',
      MODULE_INVOICES_SETTLE_OWN_INVOICE: 'Settling of own invoices',
      MODULE_INVOICES_SETTLE_OWN_INVOICE_OWNER:
        'Settling of own invoices (owner)',
      MODULE_INVOICES_SETTLE_FOREIGN_INVOICE: 'Settling of foreign invoices',
      MODULE_INVOICES_SETTLE_ADMIN_INVOICE:
        'Settling of administrative invoices',
      MODULE_INVOICES_SETTLE_ADMIN_INVOICE_OWNER:
        'Settling of administrative invoices (owner)',
      MODULE_INVOICES_MAIL_OWN_INVOICE: 'Mailing an own invoice',
      MODULE_INVOICES_MAIL_OWN_INVOICE_OWNER: 'Mailing an own invoice (owner)',
      MODULE_INVOICES_MAIL_FOREIGN_INVOICE: 'Mailing a foreign invoice',
      MODULE_INVOICES_MAIL_ADMIN_INVOICE: 'Mailing an administrative invoice',
      MODULE_INVOICES_MAIL_ADMIN_INVOICE_OWNER:
        'Mailing an administrative invoice (owner)',
      MODULE_INVOICES_EXPORT_INVOICE: 'Exporting the invoices',
      MODULE_INVOICES_CREATE_OWN_CORRECTIVE_INVOICE_FOR_NON_SYSTEM_INVOICE:
        'Adding corrective invoices for non system invoices',
    },
    REPORTS: {
      name: 'Reports and forecasts',
      MODULE_REPORTS_VIEW_ACTIVITY_REPORT:
        'Viewing and printing the activity report',
      MODULE_REPORTS_VIEW_CONTAINERS_REPORT:
        'Viewing and printing the containers report',
      MODULE_REPORTS_VIEW_INVOICES_REPORT:
        'Viewing and printing the invoices report',
      MODULE_REPORTS_VIEW_OFFERS_REPORT:
        'Viewing and printing the offers report',
      MODULE_REPORTS_VIEW_JOB_REPORT: 'Viewing and printing the jobs report',
      MODULE_REPORTS_VIEW_FORECAST: 'Viewing and printing the forecasts',
      MODULE_REPORTS_VIEW_OCEAN_SCHEDULES: 'Viewing the ocean schedules',
    },
    COUNTERPARTIES: {
      name: 'Counterparties',
      MODULE_COUNTERPARTIES_VIEW_COUNTERPARTY_DETAILS:
        "Viewing a counterparty's details",
      MODULE_COUNTERPARTIES_CREATE_COUNTERPARTY: 'Creating a counterparty',
      MODULE_COUNTERPARTIES_DELETE_COUNTERPARTY: 'Deleting a counterparty',
      MODULE_COUNTERPARTIES_EDIT_COUNTERPARTY_DETAILS:
        "Editing counterparty's details",
      MODULE_COUNTERPARTIES_ADD_COUNTERPARTY_FUNCTION:
        'Adding a function to counterparty',
      MODULE_COUNTERPARTIES_DELETE_COUNTERPARTY_FUNCTION:
        'Deleting a function to counterparty',
      MODULE_COUNTERPARTIES_MANAGE_ASSETS:
        'Managing bussines cards/accounts/lots/storages',
      MODULE_COUNTERPARTIES_MANAGE_TRUCKERS: 'Carrier management',
      MODULE_COUNTERPARTIES_DELETE_FILE: 'Deleting a file',
      MODULE_COUNTERPARTIES_EXPORT_TABLES: 'Exporting tables',
    },
    TABLES: {
      name: 'Tables',
      MODULE_TABLES_MANAGE_TABLE_ITEM: 'Managing tables',
      MODULE_TABLES_MANAGE_PORT_ITEM: 'Managing ports',
      MODULE_TABLES_EXPORT_TABLES: 'Exporting tables',
    },
    PRICES: {
      name: 'Prices',
      MODULE_PRICES_MANAGE_PRICE_ITEM: 'Managing prices',
      MODULE_PRICES_EXPORT_PRICES: 'Exporting the prices lists',
    },
    ADMIN: {
      name: 'Administration',
      MODULE_ADMIN_VIEW_GROUP_LIST: 'Viewing the list of groups',
      MODULE_ADMIN_VIEW_GROUP_DETAILS: 'Viewing the group details',
      MODULE_ADMIN_MANAGE_GROUP: 'Managing groups',
      MODULE_ADMIN_EXPORT_GROUP: 'Exporting groups',
      MODULE_ADMIN_VIEW_BRANCHES_LIST: 'Viewing the list of branches',
      MODULE_ADMIN_VIEW_BRANCHES_DETAILS: 'Viewing the branches details',
      MODULE_ADMIN_MANAGE_BRANCHES: 'Managing branches',
      MODULE_ADMIN_EXPORT_BRANCHES: 'Eksporting branches',
      MODULE_ADMIN_VIEW_USER_LIST: 'Viewing the list of users',
      MODULE_ADMIN_VIEW_USER_DETAILS: 'Viewing the user details',
      MODULE_ADMIN_MANAGE_USER: 'Managing users',
      MODULE_ADMIN_EXPORT_USERS: 'Exporting users',
      MODULE_ADMIN_VIEW_PARAMETER_LIST: 'Viewing the list of parameters',
      MODULE_ADMIN_VIEW_PARAMETER_DETAILS: 'Viewing the parameters details',
      MODULE_ADMIN_MANAGE_PARAMETER: 'Managing parameters',
      MODULE_ADMIN_EXPORT_PARAMETERS: 'Exporting parameters',
      MODULE_ADMIN_JPK: 'Accessing/generating JPK',
      MODULE_ADMIN_PRIMARY_COUNTERPARTY:
        'Accessing/modifying primary counterparty',
      MODULE_ADMIN_VIEW_ROLE_LIST: 'Viewing the list of roles',
      MODULE_ADMIN_VIEW_ROLE_DETAILS: "Viewing role's details",
      MODULE_ADMIN_MANAGE_ROLE: 'Managing roles',
      MODULE_ADMIN_EXPORT_ROLE: 'Exporting roles',
      MODULE_ADMIN_VIEW_SERVICE_TERMS_LIST: 'Viewing list of service terms',
      MODULE_ADMIN_VIEW_SERVICE_TERMS_DETAILS: "Viewing service terms' details",
      MODULE_ADMIN_MANAGE_SERVICE_TERMS: 'Manage service terms',
      MODULE_ADMIN_MONITORING: 'Application monitoring',
    },
    SETTINGS: {
      name: 'Settings',
      MODULE_SETTINGS_VIEW_DISCRIMINANT_LIST:
        'Viewing the list of discriminants',
      MODULE_SETTINGS_VIEW_DISCRIMINANT_DETAIL: 'Viewing discriminant details',
      MODULE_SETTINGS_MANAGE_DISCRIMINANT: 'Managing discriminants',
    },
    UAM: {
      name: 'My account',
      MODULE_UAM_DATA_SECTION: 'Data section',
      MODULE_UAM_REPLACEMENT_SECTION: 'Replacements section',
      MODULE_UAM_PASSWORD_SECTION: 'Password section',
      MODULE_UAM_EMAIL_SECTION: 'Email settings section',
    },
    CALENDAR: {
      name: 'Calendar',
      MODULE_CALENDAR_MANAGE_CALENDAR: 'Managing calendar',
    },
    CLIENT: {
      name: 'Client',
      MODULE_CLIENT_GENERAL: 'Client',
    },
  },
  serviceTerms: {
    allLanguagesAreSet: 'Service terms for all languages are set.',
  },
  calendar: {
    calendarLabel: 'Calendar',
    activityListLabel: 'Activity list',
    event: {
      event: 'Event',
      title: 'Title',
      allDay: 'All day',
      startDate: 'Start',
      endDate: 'End',
      participants: 'Participans',
      realized: 'Realized',
      type: {
        MEETING: 'Meeting',
        OFFER: 'Offer',
        PHONE: 'Phone',
        OTHER: 'Other',
        ALL: 'All',
      },
      activityType: 'Activity type',
      counterparty: 'Counterparty',
      counterpartysFiles: 'Counterparty files',
      description: 'Description',
      link: 'Link',
      from: 'From',
      until: 'Until',
      highPriority: 'Hight priority',
    },
    createNewEvent: 'Create an event',
    newEvent: 'New event',
    startDateBeforeEndDate: 'Start date must be before end date',
  },
  trackAndTrace: {
    // trackAndTraceStatusDescription: trackAndTraceStatusDescription,
    modalHeader: 'Track & Trace for: ',
    statusesTableModalHeader: 'Track & Trace statuses history',
    locationName: 'Message receiving location',
    status: 'Status',
    statusCode: 'Status code',
    statusCodeDecoded: 'Decoded status',
    statusDate: 'Status date',
    voyage: 'Voyage number',
    vessel: 'Vessel',
  },
  ebl: {
    modalHeader: 'eBL details for: ',
    documentType: 'Document type',
    linkToFile: 'Link to file',
    documentNumber: 'Document number',
    fileName: 'File name',
    comment: 'Comment',
  },
};
